var _defs, _path, _path2, _g, _g2, _g3, _g4, _g5, _path3, _path4, _path5, _g6, _g7, _g8, _path6, _path7, _g9, _g0, _g1, _g10, _path8, _path9, _g11, _g12, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g13, _g14, _g15, _path17, _path18, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _path19, _g26, _path20, _path21, _path22, _g27, _g28, _g29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 774.562,
    height: 524.519,
    viewBox: "0 0 774.562 524.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#d9d9d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 16.242,
    y1: -32.569,
    x2: 17.276,
    y2: -32.569,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#adadad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.026,
    y1: 0.5,
    x2: 1.025,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 0.5,
    x2: 1.034,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#85ca1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#98ed20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#98ed20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#a2fa21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#a2fa21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#95eb20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 0.5,
    x2: 1.034,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#497b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#5d9e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#5d9e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#63ab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#63ab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#5b9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#b8b8b8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#828282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1.354,
    y1: 2.112,
    x2: 0.011,
    y2: -0.372,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3c5d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#99c0cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    stopColor: "#7eb5ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#53a4c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#3999bf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -24.683,
    y1: 1.299,
    x2: -26.586,
    y2: 0.166,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#559e8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#50948c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#46798a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#375587"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -87.065,
    y1: 0.5,
    x2: -85.661,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#326a8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#2e6285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#254d6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#172c3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#0c131e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -26.184,
    y1: 0.233,
    x2: -25.918,
    y2: 0.866,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1.842,
    y1: 1.299,
    x2: -0.06,
    y2: 0.166,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3c5d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#99c4d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#7ec1db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#53bde7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#46bceb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -0.474,
    y1: 0.5,
    x2: 0.93,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#87b895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#7eae8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#66937c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#40685f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#3e665e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.341,
    y1: 0.233,
    x2: 0.607,
    y2: 0.866,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.365,
    y1: 0.94,
    x2: 0.895,
    y2: -0.445,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#060908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#16241d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    stopColor: "#314f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#568a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#578c73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 2.408,
    y1: 1.969,
    x2: -0.443,
    y2: -0.226,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -1.289,
    y1: 0.202,
    x2: 3.021,
    y2: 0.92,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0.439,
    y1: -0.247,
    x2: 0.596,
    y2: 1.674,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.456,
    y1: -0.252,
    x2: 0.566,
    y2: 1.681,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -520.899,
    y1: -1.248,
    x2: -519.878,
    y2: -1.248,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -522.329,
    y1: -4.042,
    x2: -521.31,
    y2: -4.042,
    xlinkHref: "#linear-gradient-9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_881",
    "data-name": "Groupe 881",
    transform: "translate(-170.866 -367.329)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_505",
    "data-name": "Trac\\xE9 505",
    d: "M212.512,483.227l-23.637,14.336,2.762,1.589,60.787-36.063-2.737-1.54Z",
    transform: "translate(29.972 235.149)",
    fill: "#e5e5e5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_506",
    "data-name": "Trac\\xE9 506",
    d: "M286.331,528.022l-23.637,14.336,2.762,1.588,60.786-36.063-2.737-1.54Z",
    transform: "translate(214.21 346.951)",
    fill: "#e5e5e5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_718",
    "data-name": "Groupe 718",
    transform: "translate(509.63 593.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_507",
    "data-name": "Trac\\xE9 507",
    d: "M334.9,541.882l-2.762,1.589-60.078-35.015,2.737-1.54Z",
    transform: "translate(-272.056 -245.002)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_508",
    "data-name": "Trac\\xE9 508",
    d: "M498,513.478l-2.762,1.589-139.1-81.535,2.737-1.54Z",
    transform: "translate(-62.202 -431.993)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_717",
    "data-name": "Groupe 717",
    transform: "translate(62.913 83.247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_716",
    "data-name": "Groupe 716",
    transform: "translate(0.572 1.361)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_597",
    "data-name": "Rectangle 597",
    width: 420.331,
    height: 3.164,
    transform: "matrix(0.866, -0.499, 0.499, 0.866, 0, 209.941)",
    fill: "#e5e5e5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_509",
    "data-name": "Trac\\xE9 509",
    d: "M296.022,516.424l6.894,4.042,3.447,2.021-16.31,1.347,2.521-9.431Z",
    transform: "translate(-290.053 -309.563)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_510",
    "data-name": "Trac\\xE9 510",
    d: "M401.468,463.217l-6.894-4.042-3.447-2.021,16.31-1.348-2.522,9.432Z",
    transform: "translate(-37.795 -455.806)",
    fill: "#e5e5e5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_720",
    "data-name": "Groupe 720",
    transform: "translate(224.122 732.89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_719",
    "data-name": "Groupe 719",
    transform: "translate(2.704 0.816)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_598",
    "data-name": "Rectangle 598",
    width: 3.162,
    height: 287.243,
    transform: "translate(0 2.737) rotate(-59.943)",
    fill: "#e5e5e5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_511",
    "data-name": "Trac\\xE9 511",
    d: "M196.352,479.312l6.894-4.042,3.447-2.021-16.31-1.348,2.522,9.432Z",
    transform: "translate(-190.384 -471.901)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_512",
    "data-name": "Trac\\xE9 512",
    d: "M270,514.352l-6.894,4.042-3.447,2.021,16.31,1.348-2.522-9.432Z",
    transform: "translate(-17.497 -370.996)",
    fill: "#e5e5e5"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_513",
    "data-name": "Trac\\xE9 513",
    d: "M342.29,708.916l228.92-161.947-61.022-158.51L303.2,446.694,176.866,583.367,216.3,605.816l-28.137,15.79L303,686.661l15.749,44.968,3.911-1.675-14.921-40.607,18.488,10.473,15.953,45.727,3.911-1.675-15.22-41.42Z",
    transform: "translate(0 52.736)",
    fill: "#606060",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_722",
    "data-name": "Groupe 722",
    transform: "translate(260.003 513.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_721",
    "data-name": "Groupe 721",
    transform: "translate(2.294 44.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_514",
    "data-name": "Trac\\xE9 514",
    d: "M308.621,421.9l-90.608,51.793V603.229l90.608-51.793Z",
    transform: "translate(-159.601 -421.896)",
    fill: "#d6c590"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_515",
    "data-name": "Trac\\xE9 515",
    d: "M201.3,424.809l58.412,33.714v137.49L201.3,562.3Z",
    transform: "translate(-201.304 -414.627)",
    fill: "#9c7b4f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_516",
    "data-name": "Trac\\xE9 516",
    d: "M354.257,419.185,200.648,448.8l60,34.632,93.608-53.509Z",
    transform: "translate(-200.648 -384.552)",
    fill: "#af7b56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_517",
    "data-name": "Trac\\xE9 517",
    d: "M200.648,424.585v10.739l60,34.632V459.217Z",
    transform: "translate(-200.648 -371.075)",
    fill: "#825534"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_518",
    "data-name": "Trac\\xE9 518",
    d: "M294.255,409.278l-93.607,53.51,60,34.632,93.608-53.509Z",
    transform: "translate(-200.648 -409.278)",
    fill: "#d6b78d"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_726",
    "data-name": "Groupe 726",
    transform: "translate(557.635 430.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_519",
    "data-name": "Trac\\xE9 519",
    d: "M332.24,501.374V620.258l164.511-95.236V413.077Z",
    transform: "translate(-169.854 -316.449)",
    fill: "#d9bd85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_520",
    "data-name": "Trac\\xE9 520",
    d: "M332.24,500.521l164.511-77.615v-9.487l-158.276,53.7Z",
    transform: "translate(-169.854 -315.595)",
    fill: "#ad8c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_521",
    "data-name": "Trac\\xE9 521",
    d: "M285.788,403.871,458.945,504.05l160.544-61.557v-4.538Z",
    transform: "translate(-285.788 -339.425)",
    fill: "#871002"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_522",
    "data-name": "Trac\\xE9 522",
    d: "M440.631,385.436l-151.61,55.533,161.854,101.8,160.544-58.8Z",
    transform: "translate(-277.719 -385.436)",
    fill: "#d95d4e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_724",
    "data-name": "Groupe 724",
    transform: "translate(212.19 130.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_523",
    "data-name": "Trac\\xE9 523",
    d: "M438.877,510.146l-92.39,53.887V477.99l92.39-53.774Z",
    transform: "translate(-346.487 -419.463)",
    fill: "#0d98ba"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_723",
    "data-name": "Groupe 723",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_524",
    "data-name": "Trac\\xE9 524",
    d: "M438.878,452.417l-92.391,52.9V497.9l92.391-52.862Z",
    transform: "translate(-346.487 -367.487)",
    fill: "#c6cbcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_525",
    "data-name": "Trac\\xE9 525",
    d: "M438.878,450.811l-92.391,52.863V495.65l92.391-52.826Z",
    transform: "translate(-346.487 -373.024)",
    fill: "#e1e7ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_526",
    "data-name": "Trac\\xE9 526",
    d: "M438.878,448.593l-92.391,52.828v-8.027L438.878,440.6Z",
    transform: "translate(-346.487 -378.561)",
    fill: "#c6cbcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_527",
    "data-name": "Trac\\xE9 527",
    d: "M438.878,446.373l-92.391,52.791v-8.027l92.391-52.751Z",
    transform: "translate(-346.487 -384.098)",
    fill: "#e1e7ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_528",
    "data-name": "Trac\\xE9 528",
    d: "M438.878,444.157,346.487,496.91v-8.027l92.391-52.715Z",
    transform: "translate(-346.487 -389.635)",
    fill: "#c6cbcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_529",
    "data-name": "Trac\\xE9 529",
    d: "M438.878,441.936l-92.391,52.718v-8.027l92.391-52.677Z",
    transform: "translate(-346.487 -395.171)",
    fill: "#e1e7ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_530",
    "data-name": "Trac\\xE9 530",
    d: "M438.878,439.719,346.487,492.4v-8.026l92.391-52.643Z",
    transform: "translate(-346.487 -400.709)",
    fill: "#c6cbcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_531",
    "data-name": "Trac\\xE9 531",
    d: "M438.878,437.5l-92.391,52.645V482.12l92.391-52.607Z",
    transform: "translate(-346.487 -406.246)",
    fill: "#e1e7ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_532",
    "data-name": "Trac\\xE9 532",
    d: "M438.878,435.282l-92.391,52.608v-8.025l92.391-52.57Z",
    transform: "translate(-346.487 -411.783)",
    fill: "#c6cbcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_533",
    "data-name": "Trac\\xE9 533",
    d: "M438.878,433.062l-92.391,52.572v-8.026l92.391-52.534Z",
    transform: "translate(-346.487 -417.319)",
    fill: "#e1e7ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_534",
    "data-name": "Trac\\xE9 534",
    d: "M438.878,430.846,346.487,483.38v-8.027l92.391-52.5Z",
    transform: "translate(-346.487 -422.857)",
    fill: "#c6cbcf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_535",
    "data-name": "Trac\\xE9 535",
    d: "M371.507,425.684l4.925-2.828v90.67l-4.923-2.912Z",
    transform: "translate(-284.042 -422.857)",
    fill: "#ad8c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_536",
    "data-name": "Trac\\xE9 536",
    d: "M360.02,460.431l8.95-5.37v-3.571l-8.95,5.375Z",
    transform: "translate(-312.71 -351.395)",
    fill: "#4a4a4a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_725",
    "data-name": "Groupe 725",
    transform: "translate(205.766 118.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_537",
    "data-name": "Trac\\xE9 537",
    d: "M346.137,484.46v-9.915l95.23-54.356v9.723Z",
    transform: "translate(-340.936 -417.224)",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_538",
    "data-name": "Trac\\xE9 538",
    d: "M344.649,444.79l5.2,2.98v-9.915l-5.2-2.965Z",
    transform: "translate(-344.649 -380.534)",
    fill: "#0c0f14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_539",
    "data-name": "Trac\\xE9 539",
    d: "M344.649,473.681l5.2,2.98,95.23-54.356-5.2-2.965Z",
    transform: "translate(-344.649 -419.341)",
    fill: "#787878"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_731",
    "data-name": "Groupe 731",
    transform: "translate(319.172 412.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_730",
    "data-name": "Groupe 730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_540",
    "data-name": "Trac\\xE9 540",
    d: "M422.372,533.874v207.4l-204.8-116.835v-207.4Z",
    transform: "translate(-217.574 -288.727)",
    fill: "#ad8c5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_541",
    "data-name": "Trac\\xE9 541",
    d: "M217.574,421.057v13.116l40.519,21.9,7.43-9.015Z",
    transform: "translate(-217.574 -278.7)",
    fill: "#967047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_542",
    "data-name": "Trac\\xE9 542",
    d: "M390.057,415l111.78,21.47v179l-225.679,130.9v-207.4Z",
    transform: "translate(-71.36 -293.822)",
    fill: "#d6c590"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_543",
    "data-name": "Trac\\xE9 543",
    d: "M293.237,494.669l64.051-68.218,108.979,16.929v-7.671L353.646,416.492,290.41,493.03Z",
    transform: "translate(-35.79 -290.092)",
    fill: "#ad8c5f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_729",
    "data-name": "Groupe 729",
    transform: "translate(80.066 145.383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_727",
    "data-name": "Groupe 727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_544",
    "data-name": "Trac\\xE9 544",
    d: "M321.875,598.709l-78.549,48.4-2.849-1.582V468.8l81.4-46.815Z",
    transform: "translate(-240.477 -421.756)",
    fill: "#7c96a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_545",
    "data-name": "Trac\\xE9 545",
    d: "M322.69,598.15l-81.4,46.815V468.245l78.026-45.4Z",
    transform: "translate(-238.443 -419.613)",
    fill: "#d3ded7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_546",
    "data-name": "Trac\\xE9 546",
    d: "M324.2,423.5l-2.849-1.582-80.875,47.049,2.849,1.583Z",
    transform: "translate(-240.477 -421.922)",
    fill: "#e3f6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_728",
    "data-name": "Groupe 728",
    transform: "translate(80.588 1.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_547",
    "data-name": "Trac\\xE9 547",
    d: "M264.577,599.654l118.047,71.333,2.849-1.583V492.684l-120.9-70.242Z",
    transform: "translate(-260.918 -422.442)",
    fill: "#d6c590"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_548",
    "data-name": "Trac\\xE9 548",
    d: "M263.612,600.06l121.419,69.914V493.253L263.612,422.848Z",
    transform: "translate(-263.326 -421.429)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_549",
    "data-name": "Trac\\xE9 549",
    d: "M263.816,550.154l121.419,69.912V477.732c0-2.524.01-5.048,0-7.572-.018-3.6-1.545-6.065-3.5-9.086-.343-.535-.689-1.066-1.035-1.6a19.891,19.891,0,0,0-3.58-4.517c-.762-.65-1.615-1.181-2.36-1.849-1.559-1.395-2.555-3.3-3.814-4.968a18.732,18.732,0,0,0-3.751-3.74,6.027,6.027,0,0,0-4.265-1.521c-2.527.346-6.037,5.89-6.887,8.058-1.44,3.667-2.741,5.149-5.607,7.824a72.625,72.625,0,0,0-6.845,7.107,6.275,6.275,0,0,1-2.975,2.444c-1.419.378-2.87-.315-4.233-.867-5.611-2.265-3.72,4.226-3.639,7.848.032,1.465.018,3.066-.912,4.191-.836,1.014-2.2,1.381-3.384,1.947-3.622,1.727-5.8,5.481-7.362,9.176-1.133,2.678-2.076,5.6-1.514,8.453.213,1.1.647,2.15.773,3.258a11.1,11.1,0,0,1-.343,3.566,78.765,78.765,0,0,1-2.964,10.3c-.706,1.94-1.636,4.017-3.492,4.922a7.946,7.946,0,0,1-4.656.3c-2.248-.342-4.87-1.171-5.5-3.356-.85-2.961,2.688-6.236,1.122-8.89a5.952,5.952,0,0,0-2.947-2.042,31.851,31.851,0,0,1-13.525-11.473c-1.451-2.2-2.783-4.723-5.184-5.8a15.183,15.183,0,0,0-3.782-.867,23.568,23.568,0,0,1-9.522-3.877,8.244,8.244,0,0,0-2.936-1.577c-4.415-.877-2.807,11.078-2.807,13.738Z",
    transform: "translate(-263.53 -371.522)",
    fill: "#4b7312"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_550",
    "data-name": "Trac\\xE9 550",
    d: "M368.658,401.012l212.4,121.175L460.9,501.511,248.5,380.334Z",
    transform: "translate(-140.387 -380.334)",
    fill: "#c75548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_551",
    "data-name": "Trac\\xE9 551",
    d: "M303.866,390.507l34.183,8.887L315.26,412.624l-45.577-26.277Z",
    transform: "translate(-87.521 -365.33)",
    fill: "#871002"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_552",
    "data-name": "Trac\\xE9 552",
    d: "M363.381,587.839,241.292,518.486,319.2,473.52l122.026,69.716Z",
    transform: "translate(160.795 265.03)",
    fill: "#d8d8d8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_553",
    "data-name": "Trac\\xE9 553",
    d: "M315.368,454.378a3.4,3.4,0,0,1-3.031.507,3.9,3.9,0,0,0-2.342-.4c-1.1.339-1.2,1.461-1.87,2.209a5.015,5.015,0,0,1-2.328,1.514c-1.65.776-4.667,1.108-5.82,2.552-1.374,1.72-.045,4.705-1.619,6.247-.951.933-2.468.818-3.8.766s-2.936.185-3.485,1.4c-.4.871-.063,1.916-.35,2.828-.528,1.674-2.692,2.052-4.447,2.108s-3.908.353-4.534,2c-.423,1.112-.122,2.758-1.237,3.171a2.684,2.684,0,0,1-1.269,0,5.439,5.439,0,0,0-5.544,3.331,2.8,2.8,0,0,1-.6,1.136c-.748.675-1.895.08-2.881-.126a3.579,3.579,0,0,0-3.933,2.115,6.4,6.4,0,0,1-.587,1.468c-.766,1.063-2.374.874-3.646.573.049,5.251-17.615,7.607-18.975,10.515-.213.447,0,52.241,0,64.84l71.922-42.089q.094-16.413.185-32.829C315.239,476.936,315.166,465.641,315.368,454.378Z",
    transform: "translate(164.992 217.255)",
    fill: "#77a832"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_554",
    "data-name": "Trac\\xE9 554",
    d: "M285.923,499.288l-2.115,1.2L271.513,493.1a3.118,3.118,0,0,1,.052-5.373l2.825-1.629a7.033,7.033,0,0,1,7.11.06l13.375,8Z",
    transform: "translate(232.454 294.079)",
    fill: "#7b939e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_738",
    "data-name": "Groupe 738",
    transform: "translate(514.234 772.399)"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_735",
    "data-name": "Groupe 735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_732",
    "data-name": "Groupe 732",
    transform: "translate(0 14.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_555",
    "data-name": "Trac\\xE9 555",
    d: "M282.431,494.667c5,0,9.054-2.293,9.054-5.118l.007-.881c-6.009.36-12.053.479-18.112.4l-.007.486C273.373,492.374,277.428,494.663,282.431,494.667Z",
    transform: "translate(-273.373 -483.907)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_556",
    "data-name": "Trac\\xE9 556",
    d: "M273.375,492.438c0,2.832,4.066,5.132,9.085,5.132s9.086-2.3,9.086-5.132-4.069-5.132-9.086-5.132S273.375,489.6,273.375,492.438Z",
    transform: "translate(-273.368 -487.306)",
    fill: "#f1f1f1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_557",
    "data-name": "Trac\\xE9 557",
    d: "M282.133,503.885c4.768,0,8.631-2.185,8.631-4.877l.007-14.417c-5.726.339-11.487.454-17.262.378l-.007,14.042C273.5,501.7,277.368,503.885,282.133,503.885Z",
    transform: "translate(-273.051 -479.736)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_558",
    "data-name": "Trac\\xE9 558",
    d: "M273.507,485.049l0,2.08c1.192,2.041,4.59,3.513,8.6,3.513,4.083,0,7.533-1.528,8.663-3.625v-2.349C285.039,485,279.282,485.115,273.507,485.049Z",
    transform: "translate(-273.049 -479.547)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_559",
    "data-name": "Trac\\xE9 559",
    d: "M290.764,485.357c0,2.692-3.863,4.873-8.631,4.873-4.716,0-8.547-2.136-8.628-4.789l0,10.082c0,2.692,3.866,4.877,8.631,4.877s8.631-2.185,8.631-4.877Z",
    transform: "translate(-273.051 -477.827)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_560",
    "data-name": "Trac\\xE9 560",
    d: "M290.764,485.417c0,2.692-3.863,4.877-8.631,4.877-4.716,0-8.547-2.139-8.628-4.793l0,10.085c0,2.688,3.866,4.873,8.631,4.873s8.631-2.185,8.631-4.877Z",
    transform: "translate(-273.051 -477.677)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_561",
    "data-name": "Trac\\xE9 561",
    d: "M273.5,488.184c0,2.7,3.877,4.891,8.659,4.891s8.659-2.188,8.659-4.891-3.877-4.891-8.659-4.891S273.5,485.481,273.5,488.184Z",
    transform: "translate(-273.046 -482.978)",
    fill: "#6d6d6d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_733",
    "data-name": "Groupe 733"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_562",
    "data-name": "Trac\\xE9 562",
    d: "M282.431,490.56c5,0,9.054-2.29,9.054-5.114l.007-.881c-6.009.357-12.053.479-18.112.4l-.007.486C273.373,488.27,277.428,490.56,282.431,490.56Z",
    transform: "translate(-273.373 -479.804)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_563",
    "data-name": "Trac\\xE9 563",
    d: "M273.375,488.331c0,2.835,4.066,5.135,9.085,5.132s9.086-2.3,9.086-5.132-4.069-5.132-9.086-5.128S273.375,485.5,273.375,488.331Z",
    transform: "translate(-273.368 -483.203)",
    fill: "#f1f1f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_734",
    "data-name": "Groupe 734",
    transform: "translate(0.605 0.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_564",
    "data-name": "Trac\\xE9 564",
    d: "M282.022,483.306c-4.67,0-8.453,2-8.453,4.474l-.007.769c5.607-.311,11.249-.416,16.906-.346l.007-.423C290.474,485.309,286.689,483.31,282.022,483.306Z",
    transform: "translate(-273.506 -483.306)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_565",
    "data-name": "Trac\\xE9 565",
    d: "M290.508,487.916c0-2.478-3.8-4.485-8.481-4.485s-8.481,2.007-8.481,4.485,3.8,4.489,8.481,4.489S290.508,490.395,290.508,487.916Z",
    transform: "translate(-273.546 -482.994)",
    fill: "#e9e9e9"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_736",
    "data-name": "Groupe 736",
    transform: "translate(2.566 0.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_566",
    "data-name": "Trac\\xE9 566",
    d: "M280.634,488.89c3.6,0,6.523-1.692,6.523-3.775l.007-.654c-4.331.266-8.687.353-13.053.294l0,.36C274.107,487.2,277.029,488.89,280.634,488.89Z",
    transform: "translate(-274.107 -480.944)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_567",
    "data-name": "Trac\\xE9 567",
    d: "M274.108,487.244c0,2.094,2.929,3.793,6.548,3.793s6.544-1.7,6.548-3.793-2.933-3.789-6.548-3.789S274.108,485.151,274.108,487.244Z",
    transform: "translate(-274.104 -483.455)",
    fill: "#f1f1f1"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_737",
    "data-name": "Groupe 737",
    transform: "translate(3.006 1.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_568",
    "data-name": "Trac\\xE9 568",
    d: "M286.451,486.792l0,.311v.018c0,1.807-2.734,3.268-6.107,3.268s-6.107-1.461-6.107-3.268a2.011,2.011,0,0,1,.049-.409l.007-.081c.154-1.723,2.811-3.1,6.072-3.1,3.3,0,5.988,1.405,6.086,3.16Z",
    transform: "translate(-274.233 -483.531)",
    fill: "url(#linear-gradient-9)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_569",
    "data-name": "Trac\\xE9 569",
    d: "M286.451,485.53l0,.311v.018c0,1.807-2.734,3.268-6.107,3.268s-6.107-1.461-6.107-3.268a2.011,2.011,0,0,1,.049-.409l.007-.081a14.254,14.254,0,0,1,12.158.059Z",
    transform: "translate(-271.227 -481.122)",
    fill: "#c8e608"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_570",
    "data-name": "Trac\\xE9 570",
    d: "M286.349,487.691l.032-.116c.014-.052.028-.108.038-.161a1.716,1.716,0,0,0,.021-.231l.007-.063V487.1h0l0-.311,0-.028v-.073l-.007-.028a1.339,1.339,0,0,0-.035-.238,1.733,1.733,0,0,0-.052-.192l-.032-.1c-.028-.066-.056-.129-.087-.2h0c-.7-1.388-3.055-2.409-5.869-2.409-3.262,0-5.918,1.377-6.072,3.1l-.007.081a2.011,2.011,0,0,0-.049.409,1.953,1.953,0,0,0,.353,1.087c.79-1.3,3.073-2.251,5.775-2.251a9.965,9.965,0,0,1,3.594.629h0c0,1.807-2.734,3.272-6.107,3.272-.332,0-.654-.018-.972-.045a10.128,10.128,0,0,0,3.464.58c2.842,0,5.219-1.042,5.9-2.447l.024-.056C286.3,487.824,286.325,487.757,286.349,487.691Z",
    transform: "translate(-271.227 -482.384)",
    fill: "#a6aea8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_571",
    "data-name": "Trac\\xE9 571",
    d: "M274.282,487.422c.08-1.766,2.769-3.185,6.079-3.185,3.234,0,5.869,1.349,6.069,3.052a1.346,1.346,0,0,0,.017-.168l0-.018h0l0-.311c0-1.8-2.727-3.258-6.09-3.261-3.31,0-6,1.419-6.079,3.185a1.952,1.952,0,0,0-.049.406,1.806,1.806,0,0,0,.038.363Z",
    transform: "translate(-271.227 -482.384)",
    fill: "url(#linear-gradient-10)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_754",
    "data-name": "Groupe 754",
    transform: "translate(523.323 639.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_753",
    "data-name": "Groupe 753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_752",
    "data-name": "Groupe 752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_740",
    "data-name": "Groupe 740",
    transform: "translate(70.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_739",
    "data-name": "Groupe 739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_572",
    "data-name": "Trac\\xE9 572",
    d: "M300.064,445.246l3.63,2.1-3.871,2.08-3.63-2.1Z",
    transform: "translate(-296.147 -445.246)",
    fill: "#ffbb60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_573",
    "data-name": "Trac\\xE9 573",
    d: "M299.856,612.21l-3.676-2.122.047-164.246,3.63,2.1Z",
    transform: "translate(-296.18 -443.761)",
    fill: "#b08143"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_574",
    "data-name": "Trac\\xE9 574",
    d: "M301.106,609.939l-3.875,2.26V447.926l3.875-2.081Z",
    transform: "translate(-293.557 -443.749)",
    fill: "#cf9c36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_742",
    "data-name": "Groupe 742",
    transform: "translate(0 162.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_741",
    "data-name": "Groupe 741",
    transform: "translate(0 2.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_575",
    "data-name": "Trac\\xE9 575",
    d: "M275.973,507.5v-4.191l3.518,2.186v4.191Z",
    transform: "translate(-275.973 -464.498)",
    fill: "#b08143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_576",
    "data-name": "Trac\\xE9 576",
    d: "M347.775,492.209v4.245l-70.8,40.947v-4.191Z",
    transform: "translate(-273.461 -492.209)",
    fill: "#cf9c36"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_577",
    "data-name": "Trac\\xE9 577",
    d: "M346.613,491.609l3.676,2.1-70.8,41-3.521-2.19Z",
    transform: "translate(-275.973 -491.609)",
    fill: "#ffbb60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_749",
    "data-name": "Groupe 749",
    transform: "translate(11.517 12.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_744",
    "data-name": "Groupe 744",
    transform: "translate(41.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_743",
    "data-name": "Groupe 743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_578",
    "data-name": "Trac\\xE9 578",
    d: "M294.908,448.814l3.629,2.1-3.87,2.08-3.63-2.1Z",
    transform: "translate(-290.99 -448.814)",
    fill: "#ffbb60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_579",
    "data-name": "Trac\\xE9 579",
    d: "M294.7,609.464l-3.677-2.123.047-157.932,3.63,2.1Z",
    transform: "translate(-291.024 -447.329)",
    fill: "#b08143"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_580",
    "data-name": "Trac\\xE9 580",
    d: "M295.95,607.194l-3.875,2.26V451.495l3.875-2.081Z",
    transform: "translate(-288.401 -447.318)",
    fill: "#cf9c36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_746",
    "data-name": "Groupe 746",
    transform: "translate(20.548 11.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_745",
    "data-name": "Groupe 745"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_581",
    "data-name": "Trac\\xE9 581",
    d: "M289.03,452.24l3.629,2.1-3.87,2.08-3.63-2.1Z",
    transform: "translate(-285.112 -452.24)",
    fill: "#ffbb60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_582",
    "data-name": "Trac\\xE9 582",
    d: "M288.822,612.89l-3.677-2.122.047-157.933,3.63,2.1Z",
    transform: "translate(-285.146 -450.755)",
    fill: "#b08143"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_583",
    "data-name": "Trac\\xE9 583",
    d: "M290.071,610.62l-3.875,2.26V454.92l3.875-2.081Z",
    transform: "translate(-282.523 -450.743)",
    fill: "#cf9c36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_748",
    "data-name": "Groupe 748",
    transform: "translate(0 23.951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_747",
    "data-name": "Groupe 747"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_584",
    "data-name": "Trac\\xE9 584",
    d: "M283.152,455.666l3.629,2.1-3.87,2.08-3.63-2.1Z",
    transform: "translate(-279.234 -455.666)",
    fill: "#ffbb60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_585",
    "data-name": "Trac\\xE9 585",
    d: "M282.944,616.316l-3.677-2.122.047-157.932,3.63,2.1Z",
    transform: "translate(-279.268 -454.181)",
    fill: "#b08143"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_586",
    "data-name": "Trac\\xE9 586",
    d: "M284.193,614.045l-3.875,2.26V458.346l3.875-2.08Z",
    transform: "translate(-276.645 -454.169)",
    fill: "#cf9c36"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_751",
    "data-name": "Groupe 751",
    transform: "translate(0 2.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_750",
    "data-name": "Groupe 750",
    transform: "translate(0 2.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_587",
    "data-name": "Trac\\xE9 587",
    d: "M275.973,461.736v-4.191l3.518,2.186v4.191Z",
    transform: "translate(-275.973 -418.73)",
    fill: "#b08143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_588",
    "data-name": "Trac\\xE9 588",
    d: "M347.775,446.441v4.245l-70.8,40.948v-4.191Z",
    transform: "translate(-273.461 -446.441)",
    fill: "#cf9c36"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_589",
    "data-name": "Trac\\xE9 589",
    d: "M346.613,445.841l3.676,2.1-70.8,41-3.521-2.19Z",
    transform: "translate(-275.973 -445.841)",
    fill: "#ffbb60"
  })))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_755",
    "data-name": "Groupe 755",
    transform: "translate(362.428 449.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_590",
    "data-name": "Trac\\xE9 590",
    d: "M444.138,404.517,229.948,487.67l39.659,22.981,174.531-99.983Z",
    transform: "translate(-229.948 -357.113)",
    fill: "#824703"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_591",
    "data-name": "Trac\\xE9 591",
    d: "M229.948,426.544v6.151l39.659,22.981v-6.151Z",
    transform: "translate(-229.948 -302.138)",
    fill: "#552e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_592",
    "data-name": "Trac\\xE9 592",
    d: "M404.479,415.38l-77.81-24.423L229.948,515.363l39.659,22.981,174.531-99.983Z",
    transform: "translate(-229.948 -390.956)",
    fill: "#a97b20"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_756",
    "data-name": "Groupe 756",
    transform: "translate(369.299 443.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_593",
    "data-name": "Trac\\xE9 593",
    d: "M450.549,414.278,248.262,472.322l102.353,58.82,99.934-110.714Z",
    transform: "translate(-191.109 -326.686)",
    fill: "#824703"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_594",
    "data-name": "Trac\\xE9 594",
    d: "M248.262,429.123v6.151l102.353,58.82v-6.151Z",
    transform: "translate(-191.109 -289.637)",
    fill: "#552e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_595",
    "data-name": "Trac\\xE9 595",
    d: "M393.141,405.383,248.262,488.37l102.353,58.82,99.934-110.714Z",
    transform: "translate(-191.109 -348.884)",
    fill: "#a97b20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_596",
    "data-name": "Trac\\xE9 596",
    d: "M368.824,574.542l-22.262-12.793,77.791-81.859-72.337-43-120.1,85.43L343.25,389.221l141.176,87.592Z",
    transform: "translate(-231.913 -389.221)",
    fill: "#805706"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_757",
    "data-name": "Groupe 757",
    transform: "translate(620.793 558.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_597",
    "data-name": "Trac\\xE9 597",
    d: "M314.139,429.538C304.893,439,301.194,454,305.9,462.982a11.5,11.5,0,0,0,8.939,6.467c5.307.678,11.333-1.975,16.531-7.3,9.25-9.46,12.948-24.467,8.247-33.451a11.509,11.509,0,0,0-8.939-6.464C325.368,421.557,319.341,424.214,314.139,429.538Z",
    transform: "translate(-303.855 -422.134)",
    fill: "#9c7b3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_598",
    "data-name": "Trac\\xE9 598",
    d: "M326.532,455.025c-7.331,7.46-16.259,7.858-19.989.8a5.93,5.93,0,0,1-.8-2.132c-2.265-7.194.8-17.455,7.46-24.25a30.664,30.664,0,0,1,3.331-2.8c6.527-4.663,13.455-4,16.654,2C336.922,435.7,333.856,447.429,326.532,455.025Z",
    transform: "translate(-300.982 -418.512)",
    fill: "#bda77b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_599",
    "data-name": "Trac\\xE9 599",
    d: "M322.138,450.732c-.248.248-.479.479-.727.709-4.9,4.569-10.365,5.509-13.885,2.734a8.081,8.081,0,0,1-1.779-1.968c-2.258-7.173.783-17.405,7.4-24.2l.059-.056a30.213,30.213,0,0,1,3.328-2.793c4.073-1.8,8.033-1.129,10.425,2.122a7.707,7.707,0,0,1,.766,1.206C330.8,434.477,328.259,444.478,322.138,450.732Z",
    transform: "translate(-300.981 -417.019)",
    fill: "url(#linear-gradient-11)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_600",
    "data-name": "Trac\\xE9 600",
    d: "M545.117,501.5,426.8,630.61l-23.048-13.217,12.432-13.771,98.292-108.831-13.847-7.727-113.02-64.649-29.819,32.726-81.346,89.283L214.76,509.079,332.715,380.337l62.219,35.5Z",
    transform: "translate(94.576 32.464)",
    fill: "#b63627"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_601",
    "data-name": "Trac\\xE9 601",
    d: "M264.2,400.237V389.221l133.14,76.209-6.278,7.184Z",
    transform: "translate(217.977 54.638)",
    fill: "#6b0000"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_764",
    "data-name": "Groupe 764",
    transform: "translate(336.808 614.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_761",
    "data-name": "Groupe 761",
    transform: "translate(5.52 10.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_758",
    "data-name": "Groupe 758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_602",
    "data-name": "Trac\\xE9 602",
    d: "M256.946,459.3v78.248L224.2,518.645l0-77.642Z",
    transform: "translate(-224.197 -441.003)",
    fill: "#9c9c9c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_760",
    "data-name": "Groupe 760",
    transform: "translate(3.304 1.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_759",
    "data-name": "Groupe 759"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_603",
    "data-name": "Trac\\xE9 603",
    d: "M254.587,457.987,225.145,441.53l0,74.095,29.444,17.305Z",
    transform: "translate(-225.143 -441.53)",
    fill: "#5f3b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_604",
    "data-name": "Trac\\xE9 604",
    d: "M225.87,442.631v68.76l8.168,4.551,16.2,9v-68.21l-10.8-6.251Z",
    transform: "translate(-223.327 -438.784)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_605",
    "data-name": "Trac\\xE9 605",
    d: "M225.87,511.405l7.268,4.034v-68.61l-7.268-4.2Z",
    transform: "translate(-223.327 -438.791)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_606",
    "data-name": "Trac\\xE9 606",
    d: "M233.138,460.772l-7.268,4.184v1.167l7.268,4.034,1.7.95,15.4,8.568v-9.052Z",
    transform: "translate(-223.327 -393.508)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_607",
    "data-name": "Trac\\xE9 607",
    d: "M228.452,510.333l0-66.287-2.584-1.417,0,68.764,24.375,13.553v-2.422Z",
    transform: "translate(-223.333 -438.789)",
    fill: "#452a1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_608",
    "data-name": "Trac\\xE9 608",
    d: "M225.868,463.057,228.452,462l21.791,12.192v2.422Z",
    transform: "translate(-223.333 -390.453)",
    fill: "#b48d4f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_609",
    "data-name": "Trac\\xE9 609",
    d: "M228.452,452.482l-2.584.726,24.375,13.552v-2.422Z",
    transform: "translate(-223.333 -414.198)",
    fill: "#b48d4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_610",
    "data-name": "Trac\\xE9 610",
    d: "M225.868,454.934l24.375,13.552v-2.243L225.868,452.69Z",
    transform: "translate(-223.333 -413.68)",
    fill: "#4c2f1f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_611",
    "data-name": "Trac\\xE9 611",
    d: "M227.5,516.943l-3.3,1.7,0-77.642,3.3,1.846Z",
    transform: "translate(-224.197 -441.003)",
    fill: "#7a7a7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_762",
    "data-name": "Groupe 762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_612",
    "data-name": "Trac\\xE9 612",
    d: "M261.116,465.77v-5.684l-38.5-21.588v5.574Z",
    transform: "translate(-222.619 -436.797)",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_613",
    "data-name": "Trac\\xE9 613",
    d: "M236.612,449.861l-2.981,1.708v-5.684l2.981-1.7Z",
    transform: "translate(-195.134 -422.597)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_614",
    "data-name": "Trac\\xE9 614",
    d: "M264.1,459.591l-2.98,1.708-38.5-21.588,2.98-1.7Z",
    transform: "translate(-222.619 -438.011)",
    fill: "#d4d4d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_763",
    "data-name": "Groupe 763",
    transform: "translate(0 86.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_615",
    "data-name": "Trac\\xE9 615",
    d: "M261.116,491.084V485.4l-38.5-22.125v5.573Z",
    transform: "translate(-222.619 -461.575)",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_616",
    "data-name": "Trac\\xE9 616",
    d: "M236.612,474.794l-2.981,1.708v-5.684l2.981-1.7Z",
    transform: "translate(-195.134 -446.992)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_617",
    "data-name": "Trac\\xE9 617",
    d: "M264.1,484.907l-2.98,1.707-38.5-22.125,2.98-1.7Z",
    transform: "translate(-222.619 -462.789)",
    fill: "#d4d4d4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_771",
    "data-name": "Groupe 771",
    transform: "translate(610.551 644.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_768",
    "data-name": "Groupe 768",
    transform: "translate(3.209 10.459)"
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_765",
    "data-name": "Groupe 765"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_618",
    "data-name": "Trac\\xE9 618",
    d: "M301.843,467.841v78.248l32.748-18.908,0-77.642Z",
    transform: "translate(-301.843 -449.54)",
    fill: "#bfbfbf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_767",
    "data-name": "Groupe 767",
    transform: "translate(0 1.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_766",
    "data-name": "Groupe 766"
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_619",
    "data-name": "Trac\\xE9 619",
    d: "M301.843,466.524l29.442-16.457,0,74.095-29.444,17.305Z",
    transform: "translate(-301.843 -450.067)",
    fill: "#9c7b3a"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_620",
    "data-name": "Trac\\xE9 620",
    d: "M326.937,451.168v68.76l-8.168,4.551-16.2,9V465.27l10.8-6.251Z",
    transform: "translate(-300.036 -447.321)",
    fill: "url(#linear-gradient-15)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_621",
    "data-name": "Trac\\xE9 621",
    d: "M314.727,519.942l-7.268,4.034v-68.61l7.268-4.2Z",
    transform: "translate(-287.826 -447.327)",
    fill: "url(#linear-gradient-16)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_622",
    "data-name": "Trac\\xE9 622",
    d: "M319.67,469.309l7.268,4.184v1.166l-7.268,4.034-1.7.95-15.4,8.568V479.16Z",
    transform: "translate(-300.036 -402.045)",
    fill: "url(#linear-gradient-17)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_623",
    "data-name": "Trac\\xE9 623",
    d: "M326.937,451.168v36.122l-8.168,37.189-16.2,9V511.76l10.8-52.741Z",
    transform: "translate(-300.036 -447.321)",
    fill: "url(#linear-gradient-18)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_624",
    "data-name": "Trac\\xE9 624",
    d: "M324.359,518.87l0-66.287,2.584-1.417,0,68.765-24.375,13.552v-2.422Z",
    transform: "translate(-300.034 -447.326)",
    fill: "#bda77b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_625",
    "data-name": "Trac\\xE9 625",
    d: "M326.944,471.594l-2.585-1.061-21.791,12.192v2.422Z",
    transform: "translate(-300.034 -398.989)",
    fill: "#efbc6a"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_626",
    "data-name": "Trac\\xE9 626",
    d: "M324.359,461.019l2.585.726L302.568,475.3v-2.422Z",
    transform: "translate(-300.034 -422.735)",
    fill: "#efbc6a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_627",
    "data-name": "Trac\\xE9 627",
    d: "M326.944,463.47l-24.375,13.552v-2.243l24.375-13.553Z",
    transform: "translate(-300.034 -422.217)",
    fill: "#9c7b3a"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_628",
    "data-name": "Trac\\xE9 628",
    d: "M310.267,525.48l3.3,1.7,0-77.642-3.3,1.845Z",
    transform: "translate(-280.823 -449.54)",
    fill: "#9f9f9f"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_769",
    "data-name": "Groupe 769"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_629",
    "data-name": "Trac\\xE9 629",
    d: "M301.778,474.306v-5.684l38.5-21.589v5.574Z",
    transform: "translate(-298.797 -445.334)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_630",
    "data-name": "Trac\\xE9 630",
    d: "M300.925,458.4l2.981,1.708v-5.684l-2.981-1.7Z",
    transform: "translate(-300.925 -431.134)",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_631",
    "data-name": "Trac\\xE9 631",
    d: "M300.925,468.128l2.98,1.708,38.5-21.589-2.981-1.7Z",
    transform: "translate(-300.925 -446.548)",
    fill: "#d4d4d4"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_770",
    "data-name": "Groupe 770",
    transform: "translate(0 86.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_632",
    "data-name": "Trac\\xE9 632",
    d: "M301.778,499.621v-5.684l38.5-22.125v5.573Z",
    transform: "translate(-298.797 -470.112)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_633",
    "data-name": "Trac\\xE9 633",
    d: "M300.925,483.331l2.981,1.708v-5.684l-2.981-1.7Z",
    transform: "translate(-300.925 -455.529)",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_634",
    "data-name": "Trac\\xE9 634",
    d: "M300.925,493.443l2.98,1.708,38.5-22.125-2.981-1.7Z",
    transform: "translate(-300.925 -471.326)",
    fill: "#d4d4d4"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_800",
    "data-name": "Groupe 800",
    transform: "translate(647.019 602.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_772",
    "data-name": "Groupe 772",
    transform: "translate(0 131.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_635",
    "data-name": "Trac\\xE9 635",
    d: "M346.416,510.3l-35.059-18.748v-2.914l35.059,18.749Z",
    transform: "translate(-311.357 -430.538)",
    fill: "#9d9b96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_636",
    "data-name": "Trac\\xE9 636",
    d: "M421.157,480.4l-99.771,57.819v-2.914l99.771-57.818Z",
    transform: "translate(-286.327 -458.346)",
    fill: "#b9b8b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_637",
    "data-name": "Trac\\xE9 637",
    d: "M311.363,530.094l100.293-58.079,34.517,19.16-99.78,57.683Z",
    transform: "translate(-311.343 -472.014)",
    fill: "#d8d8d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_776",
    "data-name": "Groupe 776",
    transform: "translate(25.431 8.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_775",
    "data-name": "Groupe 775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_638",
    "data-name": "Trac\\xE9 638",
    d: "M318.632,444.289l3.8,2.139V582.49l-3.8-2.139Z",
    transform: "translate(-318.632 -418.875)",
    fill: "#bda77b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_639",
    "data-name": "Trac\\xE9 639",
    d: "M319.72,463.045l44.13-25.414V573.643l-44.13,25.464Z",
    transform: "translate(-315.917 -435.492)",
    fill: "#9c7b3a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_773",
    "data-name": "Groupe 773",
    transform: "translate(9.551 15.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_640",
    "data-name": "Trac\\xE9 640",
    d: "M353.879,441.528V500.5l-32.515,18.151V459.68l10.424-5.815Z",
    transform: "translate(-321.364 -441.528)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_641",
    "data-name": "Trac\\xE9 641",
    d: "M347.294,445.2v51.812l-25.93,14.47v7.157L353.873,500.5V441.53Z",
    transform: "translate(-321.363 -441.524)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_642",
    "data-name": "Trac\\xE9 642",
    d: "M352.336,442.412v57.2l-30.972,17.259v1.771L353.872,500.5V441.53Z",
    transform: "translate(-321.363 -441.524)",
    fill: "#efbc6a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_774",
    "data-name": "Groupe 774",
    transform: "translate(9.552 79.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_643",
    "data-name": "Trac\\xE9 643",
    d: "M321.364,477.983l32.508-18.141v50.178L321.364,528.16Z",
    transform: "translate(-321.364 -459.842)",
    fill: "#85672d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_644",
    "data-name": "Trac\\xE9 644",
    d: "M352.336,460.724v48.407L321.364,526.39v1.771l32.508-18.141V459.842Z",
    transform: "translate(-321.364 -459.842)",
    fill: "#efbc6a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_645",
    "data-name": "Trac\\xE9 645",
    d: "M362.762,437.019l3.8,2.139-44.13,25.414-3.8-2.139Z",
    transform: "translate(-318.632 -437.019)",
    fill: "#dcc89e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_646",
    "data-name": "Trac\\xE9 646",
    d: "M330.224,442.412v57.2l1.536.889V441.53Z",
    transform: "translate(-289.701 -425.761)",
    fill: "#bda77b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_647",
    "data-name": "Trac\\xE9 647",
    d: "M330.224,460.724v48.407l1.536.888V459.842Z",
    transform: "translate(-289.701 -380.059)",
    fill: "#bda77b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_782",
    "data-name": "Groupe 782",
    transform: "translate(28.626 89.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_648",
    "data-name": "Trac\\xE9 648",
    d: "M324.038,460.774v9.844l-.4,7a1.346,1.346,0,0,1-.671,1.136l-1.489.86-.451.259-.29.168a.518.518,0,0,1-.5.018l-.045-.028v0a.514.514,0,0,1-.252-.43l-.4-3.667V463.242a1.355,1.355,0,0,1,.675-1.2l3.017-1.744a.53.53,0,0,1,.538,0l.017.01A.535.535,0,0,1,324.038,460.774Z",
    transform: "translate(-319.546 -460.231)",
    fill: "#aa992c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_649",
    "data-name": "Trac\\xE9 649",
    d: "M324.6,461.356l-.859,3.23-.023.134-2.531,14.836-.183,1.062L319.947,480l-.047-.026-.238-9.818.708-2.075.607-1.777,2.092-4.382.415-1.67.017.012,1.071,1.073Z",
    transform: "translate(-319.255 -460.177)",
    fill: "#aa992c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_650",
    "data-name": "Trac\\xE9 650",
    d: "M324.354,461.078v9.4l-.395,7a1.329,1.329,0,0,1-.671,1.133l-2.23,1.29a.533.533,0,0,1-.8-.447l-.024-.367-.371-3.3V463.556a1.348,1.348,0,0,1,.675-1.2l2.024-1.171.678-.392.315-.182a.521.521,0,0,1,.51-.01l.032.017A.526.526,0,0,1,324.354,461.078Z",
    transform: "translate(-318.75 -459.447)",
    fill: "#e3cb44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_651",
    "data-name": "Trac\\xE9 651",
    d: "M319.865,463.157l.392,1.507.993,8.694a1.724,1.724,0,0,1-.447.091.49.49,0,0,1-.315-.094.52.52,0,0,1-.227-.423l-.388-3.587Z",
    transform: "translate(-318.75 -452.926)",
    fill: "#baa830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_652",
    "data-name": "Trac\\xE9 652",
    d: "M325.15,461.862v5.453l-1.112-2.555-.024.014-2.744,4.782-.608.905-1.115-.65v-6.569a1.355,1.355,0,0,1,.675-1.2l3.017-1.744a.53.53,0,0,1,.538,0l.017.01,1.07,1.073.032.017A.526.526,0,0,1,325.15,461.862Z",
    transform: "translate(-319.546 -460.231)",
    fill: "#aa992c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_653",
    "data-name": "Trac\\xE9 653",
    d: "M319.546,463.277l4.733,3.185.87-2.3v-2.3a.526.526,0,0,0-.255-.455l-.032-.017-1.07-1.073-.017-.01a.53.53,0,0,0-.538,0l-3.017,1.744a1.355,1.355,0,0,0-.675,1.2Z",
    transform: "translate(-319.546 -460.231)",
    fill: "#c6b53b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_654",
    "data-name": "Trac\\xE9 654",
    d: "M323,460.239a.476.476,0,0,0-.1.042l-3.017,1.744a1.242,1.242,0,0,0-.206.15l3.345,2.381,1.279-3.048Z",
    transform: "translate(-319.211 -460.209)",
    fill: "#ead84e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_655",
    "data-name": "Trac\\xE9 655",
    d: "M324.1,460.623l-.032-.017a.521.521,0,0,0-.51.01l-.315.182-.678.392-2.024,1.171a1.348,1.348,0,0,0-.675,1.2v6.121l4.489-2.59v-6.009A.526.526,0,0,0,324.1,460.623Z",
    transform: "translate(-318.75 -459.447)",
    fill: "#d1bc36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_656",
    "data-name": "Trac\\xE9 656",
    d: "M319.907,463.453a1.2,1.2,0,0,1,.6-1.07l3.017-1.744a.378.378,0,0,1,.192-.053.4.4,0,0,1,.178.042l.024.018a.37.37,0,0,1,.185.329V466.9l-4.2,2.426Z",
    transform: "translate(-318.645 -459.343)",
    fill: "#e3cb44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_657",
    "data-name": "Trac\\xE9 657",
    d: "M319.977,470.341l.364,2.891.021.357a.511.511,0,0,0,.238.426.519.519,0,0,0,.542.011l2.174-1.258a1.3,1.3,0,0,0,.657-1.1l.385-3.849v-4.95l-4.38,2.531Z",
    transform: "translate(-318.47 -453.658)",
    fill: "#e3cb44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_658",
    "data-name": "Trac\\xE9 658",
    d: "M324.355,462.416l.282,1.567-4.38,2.529-.392-1.5Z",
    transform: "translate(-318.749 -454.776)",
    fill: "#fde457"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_659",
    "data-name": "Trac\\xE9 659",
    d: "M320.257,469.609l-.386-.265-.005-6.187.392,1.5Z",
    transform: "translate(-318.749 -452.926)",
    fill: "#d1bc36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_660",
    "data-name": "Trac\\xE9 660",
    d: "M322.032,463.439v.052a.316.316,0,0,1-.157.276l-1.251.734a.134.134,0,0,1-.2-.115v-.053a.316.316,0,0,1,.161-.276l1.248-.734A.135.135,0,0,1,322.032,463.439Z",
    transform: "translate(-317.365 -452.558)",
    fill: "#191d1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_661",
    "data-name": "Trac\\xE9 661",
    d: "M323.667,460.6a.5.5,0,0,1,.276-.066l-.2-.2a.516.516,0,0,0-.4.053l-3.017,1.744a1.355,1.355,0,0,0-.675,1.2v6.5l.322.189v-6.474a1.359,1.359,0,0,1,.675-1.2Z",
    transform: "translate(-319.276 -460.023)",
    fill: "#aa992c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_662",
    "data-name": "Trac\\xE9 662",
    d: "M323.749,460.336l0,0a.517.517,0,0,0-.4.053l-3.017,1.744a1.34,1.34,0,0,0-.671,1.192l.318.217h0a1.359,1.359,0,0,1,.675-1.2l3.017-1.744a.5.5,0,0,1,.276-.066Z",
    transform: "translate(-319.274 -460.023)",
    fill: "#c6b53b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_663",
    "data-name": "Trac\\xE9 663",
    d: "M323.047,460.328l-.045.021-3.017,1.744a1.264,1.264,0,0,0-.192.136l.311.224a1.421,1.421,0,0,1,.2-.147l2.992-1.73Z",
    transform: "translate(-318.932 -459.987)",
    fill: "#ead84e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_781",
    "data-name": "Groupe 781",
    transform: "translate(2.47 10.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_778",
    "data-name": "Groupe 778",
    transform: "translate(0 2.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_777",
    "data-name": "Groupe 777"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_664",
    "data-name": "Trac\\xE9 664",
    d: "M321.125,467.127l-.535-.308c-.325-.189-.416-.685-.269-1.252.014-.059.035-.122.056-.185l.025-.07.021-.056.025-.059c.021-.049.045-.1.07-.147l.031-.063.059-.112.066-.108.038-.059c.031-.045.059-.087.094-.129l.038-.052.038-.045.049-.059a1.268,1.268,0,0,1,.133-.14l.074-.07c.045-.042.094-.08.14-.115l.049-.038.122-.077.056-.031a1.526,1.526,0,0,1,.175-.08l.049-.017.108-.025c.035-.007.07-.01.1-.014h.073l.073.007.01,0,.035.007.021,0a.6.6,0,0,1,.129.056l.535.308a.956.956,0,0,1,.318,1.01,1.507,1.507,0,0,1-.031.164l-.014.077a2.955,2.955,0,0,1-.29.692,2.672,2.672,0,0,1-.458.594C321.925,467.145,321.453,467.316,321.125,467.127Z",
    transform: "translate(-320.253 -463.813)",
    fill: "#c4b52f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_665",
    "data-name": "Trac\\xE9 665",
    d: "M322.341,465.5l.018-.021-2.031-1.175-.007.028c-.147.566-.056,1.063.269,1.252l.535.308C321.453,466.083,321.925,465.912,322.341,465.5Z",
    transform: "translate(-320.253 -462.58)",
    fill: "#b9ab27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_666",
    "data-name": "Trac\\xE9 666",
    d: "M322.545,465.9a2.983,2.983,0,0,0,.189-.447l.014-.077a1.514,1.514,0,0,0,.031-.164.956.956,0,0,0-.318-1.01l-.535-.308a.6.6,0,0,0-.129-.056l-.014,0-.042-.007-.007,0-.077-.007h-.074c-.031,0-.066.007-.1.014l-.108.025-.049.017a1.525,1.525,0,0,0-.175.08l-.056.031-.122.077-.049.038c-.045.035-.094.073-.14.115l-.074.07a1.268,1.268,0,0,0-.133.14l-.049.059-.038.045-.038.052-.056.077Z",
    transform: "translate(-319.897 -463.813)",
    fill: "#e8d946"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_667",
    "data-name": "Trac\\xE9 667",
    d: "M322.287,464.977a.843.843,0,0,0-.308-.779l-.535-.308a.6.6,0,0,0-.129-.056l-.014,0-.042-.007-.007,0-.077-.007H321.1c-.031,0-.066.007-.1.014l-.108.025-.049.017a1.525,1.525,0,0,0-.175.08l-.056.031-.024.014Z",
    transform: "translate(-319.415 -463.813)",
    fill: "#f4e44e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_668",
    "data-name": "Trac\\xE9 668",
    d: "M320.767,466.926c.458.266,1.21-.178,1.678-.989s.479-1.685.017-1.951-1.21.178-1.678.989S320.309,466.66,320.767,466.926Z",
    transform: "translate(-319.814 -463.573)",
    fill: "#c4b52f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_780",
    "data-name": "Groupe 780",
    transform: "translate(0.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_669",
    "data-name": "Trac\\xE9 669",
    d: "M321.4,463.99a.671.671,0,0,0-.542-.035v2.636a2.7,2.7,0,0,0,.521-.654C321.855,465.126,321.862,464.256,321.4,463.99Z",
    transform: "translate(-319.338 -461.458)",
    fill: "#dac63c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_670",
    "data-name": "Trac\\xE9 670",
    d: "M320.568,464.764l.259.713,1.475-.842-.311-.7S321.173,463.694,320.568,464.764Z",
    transform: "translate(-320.072 -461.473)",
    fill: "#f2dc4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_671",
    "data-name": "Trac\\xE9 671",
    d: "M321.181,464.867v.933l-.468.5a1.043,1.043,0,0,1-.28-.891,2.521,2.521,0,0,1,.489-1.252Z",
    transform: "translate(-320.426 -460.863)",
    fill: "#dac63c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_779",
    "data-name": "Groupe 779",
    transform: "translate(0.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_672",
    "data-name": "Trac\\xE9 672",
    d: "M331.4,463.4a.732.732,0,0,0-.437.423,1.614,1.614,0,0,0-1.468.073l-5.768,3.339a.912.912,0,0,1-.9,0l-2.181-.486v.933l1.314.727a3.205,3.205,0,0,0,3.038.035l6.114-3.545a.57.57,0,0,0,.287-.521h0Z",
    transform: "translate(-320.642 -462.747)",
    fill: "#d1bc36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_673",
    "data-name": "Trac\\xE9 673",
    d: "M321.214,465.757a3.2,3.2,0,0,0,1.692.007v-1.189h-1.692Z",
    transform: "translate(-319.214 -459.812)",
    fill: "#ccbd2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_674",
    "data-name": "Trac\\xE9 674",
    d: "M322.642,464.8l-2-.444v.933l1.314.727a3.133,3.133,0,0,0,.685.28Z",
    transform: "translate(-320.642 -460.354)",
    fill: "#bcad1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_675",
    "data-name": "Trac\\xE9 675",
    d: "M320.642,467.217l1.314.731a3.2,3.2,0,0,0,3.038.035l6.114-3.548a.581.581,0,0,0,0-1.007h0a1.624,1.624,0,0,0-1.615,0l-5.768,3.339a.912.912,0,0,1-.9.007l-.706-.4Z",
    transform: "translate(-320.642 -463.212)",
    fill: "#f2dc4e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_783",
    "data-name": "Groupe 783",
    transform: "translate(21.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_676",
    "data-name": "Trac\\xE9 676",
    d: "M373.783,435.138V579.407l-2.261,1.331-1.517.851-.08.053-3.379-1.782,3.379-1.943V441.9l-3.486,2-43.978,25.9.107,139.692-3.965,2.448V467.581Z",
    transform: "translate(-314.947 -432.874)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_677",
    "data-name": "Trac\\xE9 677",
    d: "M317.557,443.773l3.651,2.261V590.39l-3.651-2.13Z",
    transform: "translate(-317.557 -411.323)",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_678",
    "data-name": "Trac\\xE9 678",
    d: "M372.737,434.491l3.651,2.261-55.18,32.45-3.651-2.13Z",
    transform: "translate(-317.557 -434.491)",
    fill: "#d4d4d4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_679",
    "data-name": "Trac\\xE9 679",
    d: "M335.853,576.8l-.08.053-3.379-1.783-.107-.054V439.079l3.512-2.022Z",
    transform: "translate(-259.121 -428.087)",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_799",
    "data-name": "Groupe 799",
    transform: "translate(85.776 28.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_789",
    "data-name": "Groupe 789",
    transform: "translate(1.367 21.252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_788",
    "data-name": "Groupe 788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_787",
    "data-name": "Groupe 787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_680",
    "data-name": "Trac\\xE9 680",
    d: "M337.7,449.495v2.454c0,.685.961,1.255,2.181,1.255s2.216-.57,2.216-1.255v-2.454Z",
    transform: "translate(-332.743 -446.427)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_784",
    "data-name": "Groupe 784",
    transform: "translate(4.95 3.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_681",
    "data-name": "Trac\\xE9 681",
    d: "M340.484,449.495H337.7v2.458h0c0,.692.968,1.251,2.188,1.251a3.586,3.586,0,0,0,.594-.07v-3.639Z",
    transform: "translate(-337.701 -449.495)",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_682",
    "data-name": "Trac\\xE9 682",
    d: "M338.726,450.586h0a1.781,1.781,0,0,0,.29-.164A2.307,2.307,0,0,1,338.726,450.586Z",
    transform: "translate(-335.143 -447.181)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_683",
    "data-name": "Trac\\xE9 683",
    d: "M338.571,450.533l.024-.007Z",
    transform: "translate(-335.53 -446.922)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_684",
    "data-name": "Trac\\xE9 684",
    d: "M338.9,450.429a1.027,1.027,0,0,0,.073-.112A.775.775,0,0,1,338.9,450.429Z",
    transform: "translate(-334.718 -447.443)",
    fill: "#6e6e6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_785",
    "data-name": "Groupe 785",
    transform: "translate(8.655 3.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_685",
    "data-name": "Trac\\xE9 685",
    d: "M338.761,449.495v3.36a1.108,1.108,0,0,0,.692-.9v-2.458Z",
    transform: "translate(-338.761 -449.495)",
    fill: "#909090"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_786",
    "data-name": "Groupe 786",
    transform: "translate(0 1.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_686",
    "data-name": "Trac\\xE9 686",
    d: "M336.285,449.021v2.458s5.37,2.468,5.974,2.692v-2.465Z",
    transform: "translate(-336.285 -449.021)",
    fill: "#5b5b5b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_687",
    "data-name": "Trac\\xE9 687",
    d: "M343.562,450.436l-5.35-1.819-1.927,1.409,5.974,2.685Z",
    transform: "translate(-336.284 -448.617)",
    fill: "#474747"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_688",
    "data-name": "Trac\\xE9 688",
    d: "M337.7,450.386c0-.689.989-1.248,2.209-1.248s2.188.559,2.188,1.248-.968,1.248-2.188,1.248S337.7,451.075,337.7,450.386Z",
    transform: "translate(-332.743 -447.318)",
    fill: "#474747"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_795",
    "data-name": "Groupe 795",
    transform: "translate(6.317 15.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_794",
    "data-name": "Groupe 794",
    transform: "translate(0 1.248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_793",
    "data-name": "Groupe 793"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_689",
    "data-name": "Trac\\xE9 689",
    d: "M337.7,447.426v6.887c0,.685.961,1.252,2.181,1.252s2.216-.566,2.216-1.252v-6.887Z",
    transform: "translate(-337.693 -447.426)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_790",
    "data-name": "Groupe 790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_690",
    "data-name": "Trac\\xE9 690",
    d: "M340.484,447.426H337.7v6.89h0c0,.689.968,1.248,2.188,1.248a3.6,3.6,0,0,0,.594-.066v-8.072Z",
    transform: "translate(-337.701 -447.426)",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_691",
    "data-name": "Trac\\xE9 691",
    d: "M338.726,449.785h0a2.086,2.086,0,0,0,.29-.164A2.3,2.3,0,0,1,338.726,449.785Z",
    transform: "translate(-335.143 -441.948)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_692",
    "data-name": "Trac\\xE9 692",
    d: "M338.571,449.732l.024-.007Z",
    transform: "translate(-335.53 -441.688)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_693",
    "data-name": "Trac\\xE9 693",
    d: "M338.9,449.624a.744.744,0,0,0,.073-.108A1,1,0,0,1,338.9,449.624Z",
    transform: "translate(-334.718 -442.21)",
    fill: "#6e6e6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_791",
    "data-name": "Groupe 791",
    transform: "translate(3.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_694",
    "data-name": "Trac\\xE9 694",
    d: "M338.761,447.426v7.792a1.108,1.108,0,0,0,.692-.9v-6.89Z",
    transform: "translate(-338.761 -447.426)",
    fill: "#909090"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_792",
    "data-name": "Groupe 792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_695",
    "data-name": "Trac\\xE9 695",
    d: "M337.7,447.426v6.89h0c0,.44.42.811,1.024,1.035v-7.925Z",
    transform: "translate(-337.701 -447.426)",
    fill: "#5b5b5b"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_696",
    "data-name": "Trac\\xE9 696",
    d: "M337.7,448.317c0-.689.989-1.248,2.209-1.248s2.188.559,2.188,1.248-.968,1.252-2.188,1.252S337.7,449.009,337.7,448.317Z",
    transform: "translate(-337.693 -447.069)",
    fill: "#898989"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_798",
    "data-name": "Groupe 798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_697",
    "data-name": "Trac\\xE9 697",
    d: "M345.09,455.849l-6.652,3.919.283-10.566,8.2-4.787Z",
    transform: "translate(-329.545 -437.855)",
    fill: "#8498a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_698",
    "data-name": "Trac\\xE9 698",
    d: "M339.03,448.481l6.044-3.529-1.83,8.938-4.5,2.661Z",
    transform: "translate(-328.776 -436.516)",
    fill: "#d8cf1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_699",
    "data-name": "Trac\\xE9 699",
    d: "M338.934,446.749l-.188,5.317,4.5-2.661.022-.11Z",
    transform: "translate(-328.776 -432.03)",
    fill: "#d6981e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_700",
    "data-name": "Trac\\xE9 700",
    d: "M337.439,455.867l6.644,3.906.284-10.567-8.2-4.787Z",
    transform: "translate(-335.21 -437.844)",
    fill: "#3b3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_701",
    "data-name": "Trac\\xE9 701",
    d: "M337.752,453.9l-1.27-8.952,6.045,3.529-.091,8.07Z",
    transform: "translate(-334.427 -436.516)",
    fill: "#726a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_702",
    "data-name": "Trac\\xE9 702",
    d: "M336.174,447.841l8.2,4.787,8.2-4.8-8.2-4.787Z",
    transform: "translate(-335.196 -441.273)",
    fill: "#ddd692"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_703",
    "data-name": "Trac\\xE9 703",
    d: "M347.7,449.173l-9.177,5.358V442.538Z",
    transform: "translate(-329.343 -442.538)",
    fill: "#596f91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_704",
    "data-name": "Trac\\xE9 704",
    d: "M335.894,449.173l9.176,5.358V442.538Z",
    transform: "translate(-335.894 -442.538)",
    fill: "#21272b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_705",
    "data-name": "Trac\\xE9 705",
    d: "M341.611,446.7l-.061,5.485-4.69-2.661-.023-.109Z",
    transform: "translate(-333.542 -432.15)",
    fill: "#422f09"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_796",
    "data-name": "Groupe 796",
    transform: "translate(2.054 8.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_706",
    "data-name": "Trac\\xE9 706",
    d: "M338.2,453.421l-1.156-8.142-.56-.328,1.27,8.952,4.683,2.648.007-.729Z",
    transform: "translate(-336.482 -444.952)",
    fill: "#807f7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_707",
    "data-name": "Trac\\xE9 707",
    d: "M337.384,447.387l-.544.307.016.12,4.684,2.657.007-.729Z",
    transform: "translate(-335.587 -438.873)",
    fill: "#525252"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_708",
    "data-name": "Trac\\xE9 708",
    d: "M342.789,453.421l1.366-7.955.91-.515-1.832,8.952-4.484,2.642.01-.775Z",
    transform: "translate(-328.767 -436.516)",
    fill: "#9e9c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_709",
    "data-name": "Trac\\xE9 709",
    d: "M342.718,447.387l.543.307-.015.12-4.5,2.657.022-.781Z",
    transform: "translate(-328.776 -430.437)",
    fill: "#737575"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_797",
    "data-name": "Groupe 797",
    transform: "translate(9.971 8.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_710",
    "data-name": "Trac\\xE9 710",
    d: "M344.181,445.372,343,451.158l-.344,1.676-.825.49-2.85,1.691Z",
    transform: "translate(-338.157 -443.896)",
    fill: "#9fcacc",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_711",
    "data-name": "Trac\\xE9 711",
    d: "M344.012,445.123l-5.253,9.735.167-4.81.07-2,1.47-.856Z",
    transform: "translate(-338.715 -444.519)",
    fill: "#9fcacc",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_712",
    "data-name": "Trac\\xE9 712",
    d: "M345.072,444.95l-.3,1.476-5.2,9.643-.825.485.045-1.265,5.253-9.735Z",
    transform: "translate(-338.746 -444.95)",
    fill: "#fff",
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_713",
    "data-name": "Trac\\xE9 713",
    d: "M340.347,445.714l-1.54,2.856.07-2Z",
    transform: "translate(-338.595 -443.042)",
    fill: "#fff",
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_714",
    "data-name": "Trac\\xE9 714",
    d: "M340.966,447.027l-.344,1.676-.825.49Z",
    transform: "translate(-336.123 -439.766)",
    fill: "#fff",
    opacity: 0.54
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_715",
    "data-name": "Trac\\xE9 715",
    d: "M342.526,448.48l-.021,1.939-.049,4.369-.021,1.767-1.73-.985-1.632-.927-1.32-.748-.215-1.529-.84-5.9-.216-1.514,1.472.863,3.005,1.75Z",
    transform: "translate(-334.429 -436.517)",
    fill: "#9fcacc",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_716",
    "data-name": "Trac\\xE9 716",
    d: "M338.319,449.349,337,448.6l-.215-1.529Z",
    transform: "translate(-333.675 -431.224)",
    fill: "#ededed",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_717",
    "data-name": "Trac\\xE9 717",
    d: "M339.329,446.614l-.021,1.939-1.546-2.855Z",
    transform: "translate(-331.233 -434.652)",
    fill: "#ededed",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_718",
    "data-name": "Trac\\xE9 718",
    d: "M342.456,454.788l-.021,1.767-1.73-.985-4.008-9.1-.216-1.514,1.472.863Z",
    transform: "translate(-334.429 -436.517)",
    fill: "#ededed",
    opacity: 0.5
  }))))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_719",
    "data-name": "Trac\\xE9 719",
    d: "M348.67,389.221,230.36,518.327l2.384,9.136L348.67,400.237Z",
    transform: "translate(133.511 54.638)",
    fill: "#871002"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_720",
    "data-name": "Trac\\xE9 720",
    d: "M262.291,399.711l6.686-7.338L395.839,464.75l-6.569,7.275Z",
    transform: "translate(213.203 62.503)",
    fill: "#b08143"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_802",
    "data-name": "Groupe 802",
    transform: "translate(375.762 460.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_801",
    "data-name": "Groupe 801",
    transform: "translate(0 2.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_721",
    "data-name": "Trac\\xE9 721",
    d: "M235.146,434.026l-1.384-3.17,3.9,2.422,1.384,3.17Z",
    transform: "translate(-233.762 -303.863)",
    fill: "#b08143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_722",
    "data-name": "Trac\\xE9 722",
    d: "M350.671,394.528l2.717,1.687L236.26,527.113l-1.384-3.17Z",
    transform: "translate(-230.98 -394.528)",
    fill: "#cf9c36"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_723",
    "data-name": "Trac\\xE9 723",
    d: "M349.384,393.863l4.072,2.326L237.661,525.6l-3.9-2.425Z",
    transform: "translate(-233.762 -393.863)",
    fill: "#ffbb60"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_804",
    "data-name": "Groupe 804",
    transform: "translate(394.052 470.577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_803",
    "data-name": "Groupe 803",
    transform: "translate(0 2.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_724",
    "data-name": "Trac\\xE9 724",
    d: "M240.378,437.026l-1.384-3.17,3.9,2.422,1.384,3.17Z",
    transform: "translate(-238.994 -306.863)",
    fill: "#b08143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_725",
    "data-name": "Trac\\xE9 725",
    d: "M355.9,397.529l2.718,1.687-117.128,130.9-1.384-3.17Z",
    transform: "translate(-236.212 -397.529)",
    fill: "#cf9c36"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_726",
    "data-name": "Trac\\xE9 726",
    d: "M354.616,396.864l4.072,2.326L242.894,528.6l-3.9-2.425Z",
    transform: "translate(-238.994 -396.864)",
    fill: "#ffbb60"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_806",
    "data-name": "Groupe 806",
    transform: "translate(412.341 481.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_805",
    "data-name": "Groupe 805",
    transform: "translate(0 2.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_727",
    "data-name": "Trac\\xE9 727",
    d: "M245.61,440.027l-1.384-3.17,3.9,2.422,1.384,3.17Z",
    transform: "translate(-244.226 -309.864)",
    fill: "#b08143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_728",
    "data-name": "Trac\\xE9 728",
    d: "M361.135,400.53l2.718,1.687-117.128,130.9-1.384-3.17Z",
    transform: "translate(-241.444 -400.53)",
    fill: "#cf9c36"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_729",
    "data-name": "Trac\\xE9 729",
    d: "M359.848,399.865l4.072,2.326L248.125,531.605l-3.9-2.425Z",
    transform: "translate(-244.226 -399.865)",
    fill: "#ffbb60"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_808",
    "data-name": "Groupe 808",
    transform: "translate(430.631 491.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_807",
    "data-name": "Groupe 807",
    transform: "translate(0 2.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_730",
    "data-name": "Trac\\xE9 730",
    d: "M250.842,443.028l-1.384-3.17,3.9,2.422,1.384,3.17Z",
    transform: "translate(-249.458 -312.865)",
    fill: "#b08143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_731",
    "data-name": "Trac\\xE9 731",
    d: "M366.367,403.53l2.718,1.687-117.128,130.9-1.384-3.17Z",
    transform: "translate(-246.676 -403.53)",
    fill: "#cf9c36"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_732",
    "data-name": "Trac\\xE9 732",
    d: "M365.08,402.865l4.072,2.326L253.358,534.606l-3.9-2.425Z",
    transform: "translate(-249.458 -402.865)",
    fill: "#ffbb60"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_810",
    "data-name": "Groupe 810",
    transform: "translate(448.921 502.046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_809",
    "data-name": "Groupe 809",
    transform: "translate(0 2.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_733",
    "data-name": "Trac\\xE9 733",
    d: "M256.074,446.028l-1.384-3.17,3.9,2.421,1.384,3.17Z",
    transform: "translate(-254.69 -315.866)",
    fill: "#b08143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_734",
    "data-name": "Trac\\xE9 734",
    d: "M371.6,406.531l2.718,1.687-117.128,130.9-1.384-3.17Z",
    transform: "translate(-251.908 -406.531)",
    fill: "#cf9c36"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_735",
    "data-name": "Trac\\xE9 735",
    d: "M370.312,405.866l4.072,2.326L258.59,537.606l-3.9-2.425Z",
    transform: "translate(-254.69 -405.866)",
    fill: "#ffbb60"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_812",
    "data-name": "Groupe 812",
    transform: "translate(467.211 512.536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_811",
    "data-name": "Groupe 811",
    transform: "translate(0 2.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_736",
    "data-name": "Trac\\xE9 736",
    d: "M261.306,449.029l-1.384-3.17,3.9,2.421,1.384,3.17Z",
    transform: "translate(-259.922 -318.867)",
    fill: "#b08143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_737",
    "data-name": "Trac\\xE9 737",
    d: "M376.831,409.532l2.718,1.687L262.42,542.116l-1.384-3.17Z",
    transform: "translate(-257.14 -409.532)",
    fill: "#cf9c36"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_738",
    "data-name": "Trac\\xE9 738",
    d: "M375.544,408.867l4.072,2.326L263.821,540.607l-3.9-2.425Z",
    transform: "translate(-259.922 -408.867)",
    fill: "#ffbb60"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_814",
    "data-name": "Groupe 814",
    transform: "translate(485.501 523.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_813",
    "data-name": "Groupe 813",
    transform: "translate(0 2.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_739",
    "data-name": "Trac\\xE9 739",
    d: "M266.538,452.03l-1.384-3.17,3.9,2.421,1.384,3.17Z",
    transform: "translate(-265.154 -321.867)",
    fill: "#b08143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_740",
    "data-name": "Trac\\xE9 740",
    d: "M382.063,412.533l2.717,1.687-117.128,130.9-1.384-3.17Z",
    transform: "translate(-262.372 -412.533)",
    fill: "#cf9c36"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_741",
    "data-name": "Trac\\xE9 741",
    d: "M380.776,411.868l4.072,2.326L269.053,543.608l-3.9-2.425Z",
    transform: "translate(-265.154 -411.868)",
    fill: "#ffbb60"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_818",
    "data-name": "Groupe 818",
    transform: "translate(399.238 777.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_815",
    "data-name": "Groupe 815"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_742",
    "data-name": "Trac\\xE9 742",
    d: "M243.621,484.642l-3.144,1.816,124.085,71.636,3.146-1.816Z",
    transform: "translate(-240.477 -484.642)",
    fill: "#f6f6f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_817",
    "data-name": "Groupe 817",
    transform: "translate(0 1.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_816",
    "data-name": "Groupe 816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_743",
    "data-name": "Trac\\xE9 743",
    d: "M240.477,485.161v2.779l124.732,71.035v-2.537Z",
    transform: "translate(-240.477 -485.161)",
    fill: "#ad8c5f"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_821",
    "data-name": "Groupe 821",
    transform: "translate(523.97 805.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_820",
    "data-name": "Groupe 820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_819",
    "data-name": "Groupe 819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_744",
    "data-name": "Trac\\xE9 744",
    d: "M354.206,492.682v2.779L276.158,540.2v-2.537Z",
    transform: "translate(-276.158 -492.682)",
    fill: "#d6c590"
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_823",
    "data-name": "Groupe 823",
    transform: "translate(399.238 602.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_822",
    "data-name": "Groupe 822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_745",
    "data-name": "Trac\\xE9 745",
    d: "M243.623,434.656l-3.146,1.816,5.588,3.273,3.146-1.816Z",
    transform: "translate(-240.477 -434.656)",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_746",
    "data-name": "Trac\\xE9 746",
    d: "M242.076,612.161l3.186-1.84-.041-174.728-3.146,1.816Z",
    transform: "translate(-236.488 -432.319)",
    fill: "#bdbdbd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_747",
    "data-name": "Trac\\xE9 747",
    d: "M240.477,435.176V610.052l5.588,3.149V438.449Z",
    transform: "translate(-240.477 -433.36)",
    fill: "#ad8c5f"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_748",
    "data-name": "Trac\\xE9 748",
    d: "M269.3,448.587l.1-.113-54.64-31.31,2.028,9.142L271.673,457.7Z",
    transform: "translate(94.576 124.378)",
    fill: "#651002"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_825",
    "data-name": "Groupe 825",
    transform: "translate(522.612 367.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_824",
    "data-name": "Groupe 824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_749",
    "data-name": "Trac\\xE9 749",
    d: "M298.558,367.329l45.578,26.278-22.789,13.229L275.77,380.559Z",
    transform: "translate(-275.77 -367.329)",
    fill: "#ffdba3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_750",
    "data-name": "Trac\\xE9 750",
    d: "M275.77,371.114l45.577,26.277v65.8L275.77,436.912Z",
    transform: "translate(-275.77 -357.884)",
    fill: "#bc8e4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_751",
    "data-name": "Trac\\xE9 751",
    d: "M311.6,374.846l-22.789,13.229v65.8l22.789,4.654Z",
    transform: "translate(-243.23 -348.568)",
    fill: "#dcad6c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_752",
    "data-name": "Trac\\xE9 752",
    d: "M323.706,388.016,291.1,369.27l-12.2,7.051,32.6,18.741Z",
    transform: "translate(-267.959 -362.485)",
    fill: "#bc8e4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_753",
    "data-name": "Trac\\xE9 753",
    d: "M291.1,369.27v14.054l-12.2-7Z",
    transform: "translate(-267.959 -362.485)",
    fill: "#dcad6c"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_754",
    "data-name": "Trac\\xE9 754",
    d: "M286.753,379.85l25.031.326-12.2,7.046Z",
    transform: "translate(274.255 31.248)",
    fill: "#a87c3d"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_755",
    "data-name": "Trac\\xE9 755",
    d: "M294.261,470.508l-23.526-13.465-1.913-8.894,23.048,13.217Z",
    transform: "translate(229.504 201.708)",
    fill: "#651002"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_756",
    "data-name": "Trac\\xE9 756",
    d: "M513.888,435.673l-3.357,8.368-116.8-18.027L277.806,553.244l-2.391-9.142L393.728,415Z",
    transform: "translate(245.959 118.971)",
    fill: "#871002"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_757",
    "data-name": "Trac\\xE9 757",
    d: "M353.879,441.528v3.749L339.8,506.559l-18.437,10.313.076-14.774,10.347-48.233Z",
    transform: "translate(360.638 185.185)",
    fill: "url(#linear-gradient-21)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_758",
    "data-name": "Trac\\xE9 758",
    d: "M325.16,427.282l-5.548,24.159c-4.9,4.569-10.365,5.509-13.885,2.734l5.621-26.166.059-.056a30.213,30.213,0,0,1,3.328-2.793C318.808,423.364,322.769,424.031,325.16,427.282Z",
    transform: "translate(321.61 141.896)",
    fill: "url(#linear-gradient-22)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_850",
    "data-name": "Groupe 850",
    transform: "translate(317.246 549.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_826",
    "data-name": "Groupe 826",
    transform: "translate(11.286 6.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_759",
    "data-name": "Trac\\xE9 759",
    d: "M225.826,423.167l2.851-1.444-5.129,93.951-2.851,1.444Z",
    transform: "translate(-219.139 -420.705)",
    fill: "#c96100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_760",
    "data-name": "Trac\\xE9 760",
    d: "M223.277,423.893l2.851-1.444-1.558-1.018-2.85,1.444Z",
    transform: "translate(-216.589 -421.431)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_761",
    "data-name": "Trac\\xE9 761",
    d: "M221.81,516.813l5.129-93.951-1.558-1.018-5.129,93.951Z",
    transform: "translate(-220.251 -420.4)",
    fill: "#ffbf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_835",
    "data-name": "Groupe 835",
    transform: "translate(13.777 9.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_827",
    "data-name": "Groupe 827",
    transform: "translate(0 82.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_762",
    "data-name": "Trac\\xE9 762",
    d: "M240.715,459.61l1.681-.852-19.723-12.925-1.681.852Z",
    transform: "translate(-220.891 -445.833)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_763",
    "data-name": "Trac\\xE9 763",
    d: "M226.707,450.383l1.682-.852-.1,1.859-1.681.852Z",
    transform: "translate(-206.883 -436.605)",
    fill: "#24715b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_764",
    "data-name": "Trac\\xE9 764",
    d: "M221.065,446.077,240.788,459l-.1,1.859-19.723-12.925Z",
    transform: "translate(-220.964 -445.225)",
    fill: "#ffbf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_828",
    "data-name": "Groupe 828",
    transform: "translate(0.617 70.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_765",
    "data-name": "Trac\\xE9 765",
    d: "M240.892,456.242l1.682-.852-19.723-12.925-1.681.852Z",
    transform: "translate(-221.068 -442.465)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_766",
    "data-name": "Trac\\xE9 766",
    d: "M226.884,447.014l1.682-.852-.1,1.859-1.681.852Z",
    transform: "translate(-207.06 -433.237)",
    fill: "#24715b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_767",
    "data-name": "Trac\\xE9 767",
    d: "M221.242,442.708l19.722,12.925-.1,1.859L221.14,444.567Z",
    transform: "translate(-221.14 -441.856)",
    fill: "#ffbf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_829",
    "data-name": "Groupe 829",
    transform: "translate(1.235 58.878)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_768",
    "data-name": "Trac\\xE9 768",
    d: "M241.068,452.873l1.682-.852L223.027,439.1l-1.681.852Z",
    transform: "translate(-221.245 -439.096)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_769",
    "data-name": "Trac\\xE9 769",
    d: "M227.06,443.645l1.682-.852-.1,1.859-1.681.852Z",
    transform: "translate(-207.236 -429.868)",
    fill: "#24715b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_770",
    "data-name": "Trac\\xE9 770",
    d: "M221.418,439.34l19.722,12.925-.1,1.859L221.317,441.2Z",
    transform: "translate(-221.317 -438.488)",
    fill: "#ffbf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_830",
    "data-name": "Groupe 830",
    transform: "translate(1.852 47.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_771",
    "data-name": "Trac\\xE9 771",
    d: "M241.245,449.5l1.682-.852L223.2,435.728l-1.682.852Z",
    transform: "translate(-221.421 -435.728)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_772",
    "data-name": "Trac\\xE9 772",
    d: "M227.237,440.277l1.682-.852-.1,1.859-1.681.852Z",
    transform: "translate(-207.413 -426.5)",
    fill: "#24715b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_773",
    "data-name": "Trac\\xE9 773",
    d: "M221.595,435.971,241.317,448.9l-.1,1.859L221.494,437.83Z",
    transform: "translate(-221.494 -435.119)",
    fill: "#ffbf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_831",
    "data-name": "Groupe 831",
    transform: "translate(2.469 35.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_774",
    "data-name": "Trac\\xE9 774",
    d: "M241.421,446.136l1.682-.852-19.723-12.925-1.681.852Z",
    transform: "translate(-221.598 -432.359)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_775",
    "data-name": "Trac\\xE9 775",
    d: "M227.413,436.908l1.682-.852-.1,1.859-1.681.852Z",
    transform: "translate(-207.589 -423.131)",
    fill: "#24715b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_776",
    "data-name": "Trac\\xE9 776",
    d: "M221.772,432.6l19.722,12.925-.1,1.859L221.67,434.462Z",
    transform: "translate(-221.67 -431.751)",
    fill: "#ffbf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_832",
    "data-name": "Groupe 832",
    transform: "translate(3.086 23.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_777",
    "data-name": "Trac\\xE9 777",
    d: "M241.6,442.768l1.682-.852-19.723-12.925-1.681.852Z",
    transform: "translate(-221.774 -428.991)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_778",
    "data-name": "Trac\\xE9 778",
    d: "M227.59,433.54l1.682-.852-.1,1.859-1.681.852Z",
    transform: "translate(-207.766 -419.763)",
    fill: "#24715b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_779",
    "data-name": "Trac\\xE9 779",
    d: "M221.948,429.234,241.67,442.16l-.1,1.859-19.722-12.925Z",
    transform: "translate(-221.847 -428.382)",
    fill: "#ffbf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_833",
    "data-name": "Groupe 833",
    transform: "translate(3.704 11.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_780",
    "data-name": "Trac\\xE9 780",
    d: "M241.775,439.4l1.682-.852-19.723-12.925-1.681.852Z",
    transform: "translate(-221.951 -425.622)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_781",
    "data-name": "Trac\\xE9 781",
    d: "M227.766,430.171l1.682-.852-.1,1.859-1.681.852Z",
    transform: "translate(-207.943 -416.394)",
    fill: "#24715b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_782",
    "data-name": "Trac\\xE9 782",
    d: "M222.125,425.866l19.722,12.925-.1,1.859-19.722-12.925Z",
    transform: "translate(-222.023 -425.014)",
    fill: "#ffbf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_834",
    "data-name": "Groupe 834",
    transform: "translate(4.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_783",
    "data-name": "Trac\\xE9 783",
    d: "M241.951,436.031l1.682-.852L223.91,422.253l-1.682.852Z",
    transform: "translate(-222.128 -422.253)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_784",
    "data-name": "Trac\\xE9 784",
    d: "M227.943,426.8l1.682-.852-.1,1.859-1.681.852Z",
    transform: "translate(-208.119 -413.026)",
    fill: "#24715b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_785",
    "data-name": "Trac\\xE9 785",
    d: "M222.3,422.5l19.722,12.925-.1,1.859L222.2,424.356Z",
    transform: "translate(-222.2 -421.645)",
    fill: "#ffbf00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_836",
    "data-name": "Groupe 836",
    transform: "translate(31.169 19.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_786",
    "data-name": "Trac\\xE9 786",
    d: "M231.514,426.882l2.851-1.444-5.129,93.951-2.851,1.444Z",
    transform: "translate(-224.826 -424.42)",
    fill: "#c96100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_787",
    "data-name": "Trac\\xE9 787",
    d: "M228.964,427.608l2.851-1.444-1.558-1.018-2.85,1.444Z",
    transform: "translate(-222.277 -425.146)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_788",
    "data-name": "Trac\\xE9 788",
    d: "M227.5,520.528l5.129-93.951-1.558-1.018-5.129,93.951Z",
    transform: "translate(-225.939 -424.116)",
    fill: "#ffbf00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_789",
    "data-name": "Trac\\xE9 789",
    d: "M225.869,458.978l1.558,1.181,2.85-1.443.351-6.962-2.85,1.443-1.566-1.034Z",
    transform: "translate(-194.944 -338.967)",
    fill: "#332c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_790",
    "data-name": "Trac\\xE9 790",
    d: "M227.427,459.867l-1.558-1.181.343-6.814,1.566,1.034Z",
    transform: "translate(-194.944 -338.675)",
    fill: "#969394"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_837",
    "data-name": "Groupe 837",
    transform: "translate(0.342 80.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_791",
    "data-name": "Trac\\xE9 791",
    d: "M225.252,444.418l3.167-1.6-7.6,144.993-3.167,1.6Z",
    transform: "translate(-215.799 -441.604)",
    fill: "#c96100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_792",
    "data-name": "Trac\\xE9 792",
    d: "M221.147,445.281l3.167-1.6-1.852-1.21-3.167,1.6Z",
    transform: "translate(-211.693 -442.468)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_793",
    "data-name": "Trac\\xE9 793",
    d: "M218.972,589.129l7.6-144.993-1.852-1.21-7.6,144.993Z",
    transform: "translate(-217.121 -441.322)",
    fill: "#ffbf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_846",
    "data-name": "Groupe 846",
    transform: "translate(3.739 104.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_838",
    "data-name": "Groupe 838",
    transform: "translate(0 104.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_794",
    "data-name": "Trac\\xE9 794",
    d: "M239.972,494.611l1.811-.918-21.848-14.318-1.812.917Z",
    transform: "translate(-218.015 -479.375)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_795",
    "data-name": "Trac\\xE9 795",
    d: "M224.452,484.389l1.811-.918-.109,2-1.811.917Z",
    transform: "translate(-202.494 -469.153)",
    fill: "#24715b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_796",
    "data-name": "Trac\\xE9 796",
    d: "M218.2,479.638l21.848,14.318-.11,2L218.092,481.64Z",
    transform: "translate(-218.092 -478.721)",
    fill: "#ffbf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_839",
    "data-name": "Groupe 839",
    transform: "translate(0.753 89.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_797",
    "data-name": "Trac\\xE9 797",
    d: "M240.187,490.34l1.811-.918L220.151,475.1l-1.812.917Z",
    transform: "translate(-218.23 -475.104)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_798",
    "data-name": "Trac\\xE9 798",
    d: "M224.667,480.118l1.811-.918-.109,2-1.811.917Z",
    transform: "translate(-202.71 -464.882)",
    fill: "#24715b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_799",
    "data-name": "Trac\\xE9 799",
    d: "M218.417,475.367l21.848,14.318-.11,2-21.848-14.318Z",
    transform: "translate(-218.308 -474.45)",
    fill: "#ffbf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_840",
    "data-name": "Groupe 840",
    transform: "translate(1.506 74.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_800",
    "data-name": "Trac\\xE9 800",
    d: "M240.4,486.069l1.811-.918-21.848-14.318-1.812.917Z",
    transform: "translate(-218.445 -470.834)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_801",
    "data-name": "Trac\\xE9 801",
    d: "M224.882,475.847l1.811-.918-.109,2-1.811.917Z",
    transform: "translate(-202.925 -460.611)",
    fill: "#24715b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_802",
    "data-name": "Trac\\xE9 802",
    d: "M218.632,471.1l21.848,14.318-.11,2L218.523,473.1Z",
    transform: "translate(-218.523 -470.179)",
    fill: "#ffbf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_841",
    "data-name": "Groupe 841",
    transform: "translate(2.259 59.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_803",
    "data-name": "Trac\\xE9 803",
    d: "M240.618,481.8l1.811-.918-21.848-14.318-1.812.917Z",
    transform: "translate(-218.661 -466.563)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_804",
    "data-name": "Trac\\xE9 804",
    d: "M225.1,471.576l1.811-.918-.109,2-1.811.917Z",
    transform: "translate(-203.141 -456.34)",
    fill: "#24715b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_805",
    "data-name": "Trac\\xE9 805",
    d: "M218.848,466.825,240.7,481.143l-.11,2-21.848-14.318Z",
    transform: "translate(-218.739 -465.908)",
    fill: "#ffbf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_842",
    "data-name": "Groupe 842",
    transform: "translate(3.012 44.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_806",
    "data-name": "Trac\\xE9 806",
    d: "M240.833,477.527l1.811-.918L220.8,462.292l-1.812.917Z",
    transform: "translate(-218.876 -462.292)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_807",
    "data-name": "Trac\\xE9 807",
    d: "M225.313,467.305l1.811-.918-.109,2-1.811.917Z",
    transform: "translate(-203.356 -452.069)",
    fill: "#24715b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_808",
    "data-name": "Trac\\xE9 808",
    d: "M219.063,462.554l21.848,14.318-.11,2-21.848-14.318Z",
    transform: "translate(-218.954 -461.637)",
    fill: "#ffbf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_843",
    "data-name": "Groupe 843",
    transform: "translate(3.765 29.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_809",
    "data-name": "Trac\\xE9 809",
    d: "M241.049,473.256l1.811-.918-21.848-14.318-1.812.917Z",
    transform: "translate(-219.092 -458.021)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_810",
    "data-name": "Trac\\xE9 810",
    d: "M225.528,463.034l1.811-.918-.109,2-1.811.917Z",
    transform: "translate(-203.571 -447.798)",
    fill: "#24715b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_811",
    "data-name": "Trac\\xE9 811",
    d: "M219.278,458.283,241.127,472.6l-.11,2-21.848-14.318Z",
    transform: "translate(-219.169 -457.366)",
    fill: "#ffbf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_844",
    "data-name": "Groupe 844",
    transform: "translate(4.518 14.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_812",
    "data-name": "Trac\\xE9 812",
    d: "M241.264,468.985l1.811-.918L221.228,453.75l-1.812.917Z",
    transform: "translate(-219.307 -453.75)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_813",
    "data-name": "Trac\\xE9 813",
    d: "M225.744,458.763l1.811-.918-.109,2-1.811.917Z",
    transform: "translate(-203.787 -443.527)",
    fill: "#24715b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_814",
    "data-name": "Trac\\xE9 814",
    d: "M219.494,454.012l21.848,14.318-.11,2-21.848-14.318Z",
    transform: "translate(-219.385 -453.095)",
    fill: "#ffbf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_845",
    "data-name": "Groupe 845",
    transform: "translate(5.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_815",
    "data-name": "Trac\\xE9 815",
    d: "M241.479,464.714l1.812-.918-21.848-14.318-1.812.917Z",
    transform: "translate(-219.522 -449.479)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_816",
    "data-name": "Trac\\xE9 816",
    d: "M225.959,454.492l1.812-.918-.109,2-1.811.917Z",
    transform: "translate(-204.002 -439.256)",
    fill: "#24715b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_817",
    "data-name": "Trac\\xE9 817",
    d: "M219.709,449.741l21.848,14.318-.109,2L219.6,451.743Z",
    transform: "translate(-219.6 -448.824)",
    fill: "#ffbf00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_849",
    "data-name": "Groupe 849",
    transform: "translate(24.024 96.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_818",
    "data-name": "Trac\\xE9 818",
    d: "M232.026,448.791l3.167-1.6-7.6,144.993-3.168,1.6Z",
    transform: "translate(-222.573 -447.187)",
    fill: "#c96100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_819",
    "data-name": "Trac\\xE9 819",
    d: "M225.746,593.5l7.6-144.993L231.5,447.3l-7.6,144.993Z",
    transform: "translate(-223.895 -446.905)",
    fill: "#ffbf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_847",
    "data-name": "Groupe 847",
    transform: "translate(9.783 4.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_820",
    "data-name": "Trac\\xE9 820",
    d: "M227.055,449.3c-.437.675-.486,1.419-.1,1.667l.493.322,1.535-2.468-.44-.287C228.16,448.291,227.5,448.633,227.055,449.3Z",
    transform: "translate(-226.693 -448.458)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_821",
    "data-name": "Trac\\xE9 821",
    d: "M228.669,448.622c-.381-.248-1.045.094-1.486.769s-.489,1.423-.108,1.671,1.049-.094,1.489-.769S229.05,448.87,228.669,448.622Z",
    transform: "translate(-226.381 -448.251)",
    fill: "#6d6d6d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_848",
    "data-name": "Groupe 848",
    transform: "translate(9.453 9.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_822",
    "data-name": "Trac\\xE9 822",
    d: "M226.963,450.812c-.44.671-.486,1.416-.108,1.664l.5.325,1.535-2.468-.441-.29C228.064,449.8,227.4,450.141,226.963,450.812Z",
    transform: "translate(-226.599 -449.963)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_823",
    "data-name": "Trac\\xE9 823",
    d: "M228.575,450.126c-.381-.248-1.045.1-1.486.773s-.489,1.423-.108,1.671,1.045-.1,1.486-.773S228.956,450.375,228.575,450.126Z",
    transform: "translate(-226.286 -449.756)",
    fill: "#6d6d6d"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_824",
    "data-name": "Trac\\xE9 824",
    d: "M223.8,500.887l1.843,1.379,3.167-1.6.744-14.195-3.167,1.6-1.852-1.209Z",
    transform: "translate(-200.115 -252.332)",
    fill: "#332c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_825",
    "data-name": "Trac\\xE9 825",
    d: "M225.64,501.984l-1.843-1.379.735-14.025,1.852,1.209Z",
    transform: "translate(-200.115 -252.05)",
    fill: "#969394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_826",
    "data-name": "Trac\\xE9 826",
    d: "M217.023,496.513l1.843,1.379,3.168-1.6.744-14.195-3.167,1.6-1.852-1.21Z",
    transform: "translate(-217.023 -263.247)",
    fill: "#332c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_827",
    "data-name": "Trac\\xE9 827",
    d: "M218.866,497.61l-1.843-1.379.736-14.025,1.852,1.21Z",
    transform: "translate(-217.023 -262.966)",
    fill: "#969394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_828",
    "data-name": "Trac\\xE9 828",
    d: "M227.416,430.692l1.558,1.182,2.85-1.443.351-6.962-2.85,1.443-1.566-1.034Z",
    transform: "translate(-191.084 -409.564)",
    fill: "#5f595b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_829",
    "data-name": "Trac\\xE9 829",
    d: "M228.974,431.581l-1.558-1.182.343-6.814,1.566,1.034Z",
    transform: "translate(-191.084 -409.271)",
    fill: "#332c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_830",
    "data-name": "Trac\\xE9 830",
    d: "M229.114,425.722l-1.6-1.106,2.85-1.443,1.566,1.034Z",
    transform: "translate(-190.839 -410.302)",
    fill: "#bab8b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_831",
    "data-name": "Trac\\xE9 831",
    d: "M221.719,427.01l1.558,1.182,2.85-1.443.351-6.962-2.85,1.443-1.566-1.034Z",
    transform: "translate(-205.303 -418.753)",
    fill: "#5f595b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_832",
    "data-name": "Trac\\xE9 832",
    d: "M223.277,427.9l-1.558-1.182.343-6.814,1.566,1.034Z",
    transform: "translate(-205.303 -418.46)",
    fill: "#332c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_833",
    "data-name": "Trac\\xE9 833",
    d: "M223.417,422.04l-1.6-1.106,2.85-1.443,1.566,1.034Z",
    transform: "translate(-205.058 -419.491)",
    fill: "#bab8b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_834",
    "data-name": "Trac\\xE9 834",
    d: "M227.921,449.658l3.167-1.6-1.852-1.209-3.167,1.6Z",
    transform: "translate(-194.444 -351.22)",
    fill: "#ffa200"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_853",
    "data-name": "Groupe 853",
    transform: "translate(415.576 762.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_835",
    "data-name": "Trac\\xE9 835",
    d: "M284.557,488.549,259.243,503.2l-14.092-8.156,25.314-14.654Z",
    transform: "translate(-245.151 -480.394)",
    fill: "#7b939e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_836",
    "data-name": "Trac\\xE9 836",
    d: "M256.048,481.854l59.3,33.926-1.534.89-59.3-33.913Z",
    transform: "translate(-221.784 -476.749)",
    fill: "#7b939e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_837",
    "data-name": "Trac\\xE9 837",
    d: "M274,491.108l-3.9,2.038,2.373,1.436,3.98-2.143Z",
    transform: "translate(-182.884 -453.654)",
    fill: "#7b939e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_851",
    "data-name": "Groupe 851",
    transform: "translate(19.238 10.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_838",
    "data-name": "Trac\\xE9 838",
    d: "M287.7,491.568l-23.286,13.481-3.4-2.3,23.285-13.48Z",
    transform: "translate(-224.793 -468.432)",
    fill: "#7b939e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_839",
    "data-name": "Trac\\xE9 839",
    d: "M284.248,489.581l-23.286,13.481-3.4-2.3,23.285-13.48Z",
    transform: "translate(-233.413 -473.392)",
    fill: "#7b939e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_840",
    "data-name": "Trac\\xE9 840",
    d: "M280.794,487.594l-23.286,13.481-3.4-2.3,23.285-13.48Z",
    transform: "translate(-242.034 -478.351)",
    fill: "#7b939e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_841",
    "data-name": "Trac\\xE9 841",
    d: "M277.34,485.607l-23.286,13.481-3.4-2.3,23.285-13.48Z",
    transform: "translate(-250.654 -483.31)",
    fill: "#7b939e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_852",
    "data-name": "Groupe 852",
    transform: "translate(9.544 18.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_842",
    "data-name": "Trac\\xE9 842",
    d: "M249.415,485.674l59.3,33.927-1.534.89-59.3-33.913Z",
    transform: "translate(-247.881 -485.674)",
    fill: "#7b939e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_843",
    "data-name": "Trac\\xE9 843",
    d: "M267.378,494.938l-3.9,2.038,2.373,1.436,3.98-2.143Z",
    transform: "translate(-199.403 -444.093)",
    fill: "#7b939e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_844",
    "data-name": "Trac\\xE9 844",
    d: "M256.028,488.271l-3.9,2.038,2.373,1.437,3.98-2.143Z",
    transform: "translate(-227.731 -460.733)",
    fill: "#7b939e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_845",
    "data-name": "Trac\\xE9 845",
    d: "M262.7,484.43l-3.9,2.038,2.373,1.436,3.98-2.143Z",
    transform: "translate(-211.085 -470.32)",
    fill: "#7b939e"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_880",
    "data-name": "Groupe 880",
    transform: "translate(442.349 713.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_879",
    "data-name": "Groupe 879",
    transform: "translate(0.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_857",
    "data-name": "Groupe 857",
    transform: "translate(23.184 13.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_854",
    "data-name": "Groupe 854",
    transform: "translate(0 0.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_846",
    "data-name": "Trac\\xE9 846",
    d: "M285.623,470.622,259.7,522.388l1.86,1.077,25.554-52Z",
    transform: "translate(-259.698 -470.557)",
    fill: "#c96100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_847",
    "data-name": "Trac\\xE9 847",
    d: "M287.3,470.6l-25.532,52.019-1.534.89,25.533-52.005Z",
    transform: "translate(-258.372 -470.603)",
    fill: "#db7900"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_856",
    "data-name": "Groupe 856",
    transform: "translate(25.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_855",
    "data-name": "Groupe 855"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_848",
    "data-name": "Trac\\xE9 848",
    d: "M270.114,471.141l-1.514-.754-1.486.819,1.479.84Z",
    transform: "translate(-267.114 -470.387)",
    fill: "#ffbf00"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_858",
    "data-name": "Groupe 858",
    transform: "translate(12.354 42.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_849",
    "data-name": "Trac\\xE9 849",
    d: "M256.993,492.682v1.105l23.943-13.969v-1.105Z",
    transform: "translate(-255.619 -477.92)",
    fill: "#db7900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_850",
    "data-name": "Trac\\xE9 850",
    d: "M257.975,483.276v1.105l-1.374-.793v-1.105Z",
    transform: "translate(-256.6 -468.514)",
    fill: "#87560c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_851",
    "data-name": "Trac\\xE9 851",
    d: "M281.917,479.28l-23.943,13.969-1.374-.793,23.942-13.969Z",
    transform: "translate(-256.6 -478.487)",
    fill: "#ffbf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_862",
    "data-name": "Groupe 862",
    transform: "translate(47.864 1.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_859",
    "data-name": "Groupe 859",
    transform: "translate(0.001 0.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_852",
    "data-name": "Trac\\xE9 852",
    d: "M266.758,467.138l14.626,85.182,1.877,1.077-15.014-85.419Z",
    transform: "translate(-266.758 -467.074)",
    fill: "#c96100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_853",
    "data-name": "Trac\\xE9 853",
    d: "M268.711,467.12l15.036,85.434-1.534.89-15.036-85.42Z",
    transform: "translate(-265.712 -467.12)",
    fill: "#ffa200"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_861",
    "data-name": "Groupe 861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_860",
    "data-name": "Groupe 860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_854",
    "data-name": "Trac\\xE9 854",
    d: "M269.758,467.657l-1.514-.754-1.486.819,1.479.84Z",
    transform: "translate(-266.758 -466.904)",
    fill: "#f4f4f4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_867",
    "data-name": "Groupe 867",
    transform: "translate(28.915 34.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_863",
    "data-name": "Groupe 863",
    transform: "translate(7.406 42.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_855",
    "data-name": "Trac\\xE9 855",
    d: "M265.186,502.92v.99l23.286-13.481v-.99Z",
    transform: "translate(-259.139 -485.945)",
    fill: "#3a3f41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_856",
    "data-name": "Trac\\xE9 856",
    d: "M269.5,495.79v.99l-6.047-3.495V492.3Z",
    transform: "translate(-263.456 -478.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_857",
    "data-name": "Trac\\xE9 857",
    d: "M292.788,491.933,269.5,505.414l-6.047-3.495,23.285-13.48Z",
    transform: "translate(-263.456 -488.44)",
    fill: "#919596"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_864",
    "data-name": "Groupe 864",
    transform: "translate(4.937 28.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_858",
    "data-name": "Trac\\xE9 858",
    d: "M264.479,498.826v.99l23.286-13.482v-.99Z",
    transform: "translate(-258.433 -481.851)",
    fill: "#3a3f41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_859",
    "data-name": "Trac\\xE9 859",
    d: "M268.8,491.7v.99l-6.047-3.495V488.2Z",
    transform: "translate(-262.75 -474.721)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_860",
    "data-name": "Trac\\xE9 860",
    d: "M292.082,487.839,268.8,501.32l-6.047-3.495,23.285-13.48Z",
    transform: "translate(-262.75 -484.345)",
    fill: "#919596"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_865",
    "data-name": "Groupe 865",
    transform: "translate(2.469 14.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_861",
    "data-name": "Trac\\xE9 861",
    d: "M263.773,494.732v.99l23.286-13.482v-.99Z",
    transform: "translate(-257.726 -477.757)",
    fill: "#3a3f41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_862",
    "data-name": "Trac\\xE9 862",
    d: "M268.09,487.6v.99l-6.047-3.5v-.989Z",
    transform: "translate(-262.043 -470.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_863",
    "data-name": "Trac\\xE9 863",
    d: "M291.376,483.745,268.09,497.226l-6.047-3.495,23.285-13.48Z",
    transform: "translate(-262.043 -480.252)",
    fill: "#919596"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_866",
    "data-name": "Groupe 866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_864",
    "data-name": "Trac\\xE9 864",
    d: "M263.067,490.638v.99l23.286-13.482v-.99Z",
    transform: "translate(-257.02 -473.663)",
    fill: "#3a3f41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_865",
    "data-name": "Trac\\xE9 865",
    d: "M267.384,483.507v.99l-6.047-3.5v-.989Z",
    transform: "translate(-261.337 -466.533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_866",
    "data-name": "Trac\\xE9 866",
    d: "M290.67,479.651l-23.286,13.481-6.047-3.495,23.285-13.48Z",
    transform: "translate(-261.337 -476.157)",
    fill: "#919596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_868",
    "data-name": "Groupe 868",
    transform: "translate(21.261 16.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_867",
    "data-name": "Trac\\xE9 867",
    d: "M262.856,486.692v.99L286.142,474.2v-.989Z",
    transform: "translate(-249.893 -465.71)",
    fill: "#3a3f41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_868",
    "data-name": "Trac\\xE9 868",
    d: "M272.111,482.423v.99l-12.963-7.5v-.989Z",
    transform: "translate(-259.148 -461.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_869",
    "data-name": "Trac\\xE9 869",
    d: "M295.4,478.566l-23.286,13.481-12.963-7.5,23.285-13.48Z",
    transform: "translate(-259.148 -471.065)",
    fill: "#919596"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_872",
    "data-name": "Groupe 872",
    transform: "translate(0 27.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_870",
    "data-name": "Groupe 870",
    transform: "translate(25.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_869",
    "data-name": "Groupe 869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_870",
    "data-name": "Trac\\xE9 870",
    d: "M263.481,474.962l-1.514-.754-1.486.819,1.479.84Z",
    transform: "translate(-260.481 -474.208)",
    fill: "#ffbf00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_871",
    "data-name": "Groupe 871",
    transform: "translate(0 0.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_871",
    "data-name": "Trac\\xE9 871",
    d: "M278.987,474.442l-25.921,51.766,1.86,1.077,25.551-52Z",
    transform: "translate(-253.066 -474.377)",
    fill: "#c96100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_872",
    "data-name": "Trac\\xE9 872",
    d: "M280.663,474.423l-25.532,52.019-1.534.89,25.532-52.006Z",
    transform: "translate(-251.741 -474.423)",
    fill: "#db7900"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_877",
    "data-name": "Groupe 877",
    transform: "translate(24.677 15.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_874",
    "data-name": "Groupe 874",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_873",
    "data-name": "Groupe 873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_873",
    "data-name": "Trac\\xE9 873",
    d: "M263.125,471.478l-1.515-.754-1.485.819,1.479.84Z",
    transform: "translate(-260.125 -470.724)",
    fill: "#f4f4f4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_875",
    "data-name": "Groupe 875",
    transform: "translate(1.467 0.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_874",
    "data-name": "Trac\\xE9 874",
    d: "M262.079,470.94l15.036,85.434-1.534.89-15.036-85.421Z",
    transform: "translate(-260.545 -470.94)",
    fill: "#ffa200"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_876",
    "data-name": "Groupe 876",
    transform: "translate(1.467 0.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_875",
    "data-name": "Trac\\xE9 875",
    d: "M262.079,470.94l15.036,85.434-1.534.89-15.036-85.421Z",
    transform: "translate(-260.545 -470.94)",
    fill: "#ffa200"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_876",
    "data-name": "Trac\\xE9 876",
    d: "M260.125,470.959l14.63,85.178,1.877,1.077-15.018-85.419Z",
    transform: "translate(-260.125 -470.139)",
    fill: "#c96100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_878",
    "data-name": "Groupe 878",
    transform: "translate(23.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_877",
    "data-name": "Trac\\xE9 877",
    d: "M260.6,480.737l.543,3.262,24.846-14.344-.543-3.263Z",
    transform: "translate(-257.582 -466.393)",
    fill: "#99cf16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_878",
    "data-name": "Trac\\xE9 878",
    d: "M262.79,471.094l-2.035,1.163.543,3.262,2.035-1.175Z",
    transform: "translate(-257.194 -454.662)",
    fill: "#99cf16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_879",
    "data-name": "Trac\\xE9 879",
    d: "M262.755,470.5l.543,3.262-3.018.535-.543-3.262Z",
    transform: "translate(-259.737 -456.153)",
    fill: "#5f781b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_880",
    "data-name": "Trac\\xE9 880",
    d: "M262.909,471.43l.543,3.263-3.018.535-.543-3.262Z",
    transform: "translate(-259.35 -453.824)",
    fill: "#5f781b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_881",
    "data-name": "Trac\\xE9 881",
    d: "M287.6,466.393l-24.846,14.344-3.018.535,24.846-14.343Z",
    transform: "translate(-259.737 -466.393)",
    fill: "#baf21f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_882",
    "data-name": "Trac\\xE9 882",
    d: "M269.315,467.326l-2.035,1.164.543,3.262,2.036-1.175Z",
    transform: "translate(-217.591 -464.067)",
    fill: "#99cf16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_883",
    "data-name": "Trac\\xE9 883",
    d: "M266.469,469.3l.359,2.157,3.018-.536-.542-3.258Z",
    transform: "translate(-219.615 -463.224)",
    fill: "#5f781b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_884",
    "data-name": "Trac\\xE9 884",
    d: "M266.868,494.72l-2.035,1.163.543,3.262,2.036-1.175Z",
    transform: "translate(-223.698 -395.696)",
    fill: "#99cf16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_885",
    "data-name": "Trac\\xE9 885",
    d: "M268.951,494.761l-2.034,1.182-2.92-.208.823-.475.057.288,1.677.08,1.547-.81-.02-.115Z",
    transform: "translate(-225.783 -395.738)",
    fill: "#b8ea5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_886",
    "data-name": "Trac\\xE9 886",
    d: "M273.5,490.9l-2.035,1.164.543,3.262,2.035-1.175Z",
    transform: "translate(-207.155 -405.242)",
    fill: "#99cf16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_887",
    "data-name": "Trac\\xE9 887",
    d: "M273.546,491.378l.543,3.263-2.919-.205-.543-3.262Z",
    transform: "translate(-209.237 -404.549)",
    fill: "#5f781b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_888",
    "data-name": "Trac\\xE9 888",
    d: "M275.581,490.936l-2.033,1.182-2.92-.209.823-.475.057.289,1.677.079,1.547-.809-.02-.115Z",
    transform: "translate(-209.237 -405.286)",
    fill: "#b8ea5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_889",
    "data-name": "Trac\\xE9 889",
    d: "M256.993,488.756l-1.953,1.07-1.494,2.487,2.035-1.175Z",
    transform: "translate(-251.867 -410.581)",
    fill: "#99cf16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_890",
    "data-name": "Trac\\xE9 890",
    d: "M257.763,489.647l-1.951,1.089-2.575-1.84.9-.5-.286.584,1.732,1.268,1.5-.831.11-.218Z",
    transform: "translate(-252.64 -411.473)",
    fill: "#b8ea5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_891",
    "data-name": "Trac\\xE9 891",
    d: "M263.638,484.915l-1.953,1.07-1.494,2.487,2.036-1.175Z",
    transform: "translate(-235.284 -420.168)",
    fill: "#99cf16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_892",
    "data-name": "Trac\\xE9 892",
    d: "M263.522,486.535l-1.494,2.487-2.574-1.837,1.494-2.487Z",
    transform: "translate(-237.122 -420.707)",
    fill: "#5f781b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_893",
    "data-name": "Trac\\xE9 893",
    d: "M264.408,485.806l-1.951,1.089-2.575-1.84.9-.5-.286.584,1.732,1.268,1.5-.834.11-.217Z",
    transform: "translate(-236.056 -421.06)",
    fill: "#b8ea5d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_894",
    "data-name": "Trac\\xE9 894",
    d: "M266.916,495.2l.543,3.262-2.919-.205L264,495Z",
    transform: "translate(-224.887 -395.003)",
    fill: "#5f781b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_895",
    "data-name": "Trac\\xE9 895",
    d: "M256.878,490.376l-1.494,2.487-2.574-1.837,1.494-2.487Z",
    transform: "translate(-252.81 -411.12)",
    fill: "#5f781b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.5cee2296796fe1beca26610bd4d104cb.svg";
export { ForwardRef as ReactComponent };